/** UI copy: Latin American Neutral Spanish (tú). Prefer "baraja" over "mazo". */
export const es = {
  maintenance: {
    title: 'Mantenimiento',
    body: 'Estamos preparando la siguiente expansión. El sitio vuelve solo cuando termine.',
  },
  card: {
    attr: {
      DARK: 'OSCURIDAD',
      LIGHT: 'LUZ',
      FIRE: 'FUEGO',
      WATER: 'AGUA',
      EARTH: 'TIERRA',
      WIND: 'VIENTO',
    },
    race: {
      Aqua: 'Aqua',
      Beast: 'Bestia',
      'Beast-Warrior': 'Guerrero-Bestia',
      Continuous: 'Continua',
      Dinosaur: 'Dinosaurio',
      Dragon: 'Dragón',
      Equip: 'Equipo',
      Fairy: 'Hada',
      Field: 'Campo',
      Fiend: 'Demonio',
      Fish: 'Pez',
      Insect: 'Insecto',
      Machine: 'Máquina',
      Normal: 'Normal',
      Plant: 'Planta',
      Pyro: 'Piro',
      Reptile: 'Reptil',
      Rock: 'Roca',
      'Sea Serpent': 'Serpiente Marina',
      Spellcaster: 'Lanzador de Conjuros',
      Thunder: 'Trueno',
      Warrior: 'Guerrero',
      'Winged Beast': 'Bestia Alada',
      Zombie: 'Zombi',
    },
    type: {
      'Normal Monster': 'Monstruo Normal',
      'Effect Monster': 'Monstruo de Efecto',
      'Flip Effect Monster': 'Monstruo de Efecto de Volteo',
      'Fusion Monster': 'Monstruo de Fusión',
      'Spell Card': 'Carta Mágica',
      'Trap Card': 'Carta de Trampa',
    },
    stType: {
      'Normal Spell': 'Mágica Normal',
      'Equip Spell': 'Mágica de Equipo',
      'Field Spell': 'Mágica de Campo',
      'Continuous Spell': 'Mágica Continua',
      'Normal Trap': 'Trampa Normal',
      'Continuous Trap': 'Trampa Continua',
    },
    token: {
      Normal: 'Normal',
      Effect: 'Efecto',
      Fusion: 'Fusión',
      Flip: 'Volteo',
    },
  },
  mobile: {
    rotateTitle: 'Gira el teléfono',
    rotateHint: 'El duelo se juega en horizontal.',
    close: 'Cerrar',
    closeMenu: 'Cerrar menú',
    menu: 'Menú',
    filters: 'Filtros',
  },
  nav: {
    brand: 'Dueling Chaos',
    home: 'Inicio',
    packs: 'Sobres',
    deckBuilder: 'Baraja',
    collection: 'Colección',
    duel: 'Duelo',
    duelPick: '¿Cómo quieres jugar?',
    duelVsAi: 'Duelo vs IA',
    duelVsAiHint: 'Tu baraja contra la CPU.',
    duelRanked: 'Clasificatoria en línea',
    duelRankedHint: 'Partida rápida contra otro duelista.',
    duelCasual: 'Cola casual',
    duelCasualHint: 'Tu liga no se mueve.',
    duelEventHint: 'Una cola semanal. Una victoria paga un Master Pack. Tu liga no se mueve.',
    queueWaiting: '{n} en cola',
    queueClosed: 'Clasificatoria en pausa',
    rankedOfferHint: '{n} monedas solo por jugar',
    duelCancel: 'Cancelar',
    missions: 'Misiones',
    news: 'Novedades',
    banlist: 'Banlist',
    popular: 'Populares',
    tournaments: 'Torneos',
    faq: 'FAQ',
    mailbox: 'Buzón',
    language: 'Idioma',
    account: 'Cuenta',
    settings: 'Ajustes',
    profile: 'Perfil',
    friends: 'Amigos',
    admin: 'Admin',
    rank: 'Clasificatoria',
    menu: 'Menú de cuenta',
    loading: 'Cargando',
    fullscreen: 'Pantalla completa',
    fullscreenExit: 'Salir de pantalla completa',
  },
  splash: {
    skip: 'Saltar',
  },
  coins: {
    balance: 'Monedas',
  },
  interrupt: {
    toast: 'El duelo se cortó por una actualización. Te dimos {n} monedas.',
  },
  bugReward: {
    toast: 'El error que reportaste era real. Te dimos 1 moneda y 1 Master Pack.',
    toastMany: 'Los errores que reportaste eran reales. Te dimos {n} monedas y {n} Master Packs.',
  },
  staffGrant: {
    toastCoin: 'Te dimos 1 moneda.',
    toastCoins: 'Te dimos {n} monedas.',
    toastPack: 'Te dimos 1 Master Pack.',
    toastPacks: 'Te dimos {n} Master Packs.',
    toastBoth: 'Te dimos {coins} monedas y {packs} Master Packs.',
  },
  mailbox: {
    kicker: 'Cuenta',
    title: 'Buzón',
    lead: 'Novedades por revisar y mensajes del equipo.',
    back: 'Inicio',
    news: 'Novedades',
    messages: 'Mensajes',
    reviewNews: 'Revisar',
    team: 'Equipo',
    dialogTitle: 'Mensaje',
    claim: 'Reclamar',
    claiming: 'Reclamando…',
    claimed: 'Reclamado',
    gotIt: 'Entendido',
    close: 'Cerrar',
    coin: '1 moneda',
    coins: '{n} monedas',
    pack: '1 Master Pack',
    packs: '{n} Master Packs',
    rewardBoth: '{coins} y {packs}',
    claimError: 'No se pudo reclamar esta recompensa.',
    empty: 'No hay mensajes.',
    loading: 'Cargando…',
    loadError: 'No se pudo cargar tu buzón.',
    pendingBadge: '{n} sin leer',
    clearSettled: 'Limpiar leídos y reclamados',
    clearing: 'Limpiando…',
    clearError: 'No se pudo limpiar el buzón.',
    seasonCpu:
      'Quedaste #{position} en el ladder de {difficulty} esta temporada. Aquí tienes 1 Master Pack.',
    playtimeMrd:
      'Eres el #{position} por horas jugadas. Aquí tienes un sobre especial de Metal Raiders: 5 cartas Ultra Rare o más.',
    playtimePack: '1 sobre especial de Metal Raiders',
    tournament: {
      champion: 'Ganaste el torneo de eliminación directa. Aquí tienes {coins} monedas y un Master Pack.',
      finalist: 'Llegaste a la final. Aquí tienes {coins} monedas y un Master Pack.',
      semi: 'Llegaste a semifinales. Aquí tienes {coins} monedas y un Master Pack.',
      quarters: 'Llegaste a cuartos. Aquí tienes {coins} monedas y un Master Pack.',
      eighths: 'Llegaste a octavos. Aquí tienes {coins} monedas y un Master Pack.',
      play: 'Jugaste el torneo de eliminación directa. Aquí tienes un Master Pack.',
    },
    eventQueue:
      'Quedaste #{position} en la cola de {mode}. Aquí tienes tu premio.',
  },
  eventQueue: {
    kicker: 'Esta semana',
    lead: 'Victorias de la cola de evento rotativa. Un duelo terminado paga 7 monedas al ganar y 5 al perder o empatar, igual que clasificatoria. Al cerrar la semana, el porcentaje se cuenta entre quienes ganaron al menos un duelo. Cobras una sola banda de Master Packs: 20 el top 1%, 15 el resto del top 10%, 8 el resto del top 25%, 4 el resto del top 50% y 2 el resto. Un empate en victorias y derrotas en el corte cobra la banda de arriba.',
    board: 'Esta semana',
    boardEmpty: 'Todavía no hay victorias.',
    empty: 'No hay un evento en curso.',
    loading: 'Cargando…',
    liveUntil: 'Termina {time}',
    endsIn: 'Termina en {time}',
    closed: 'Este evento ya cerró.',
    modes: {
      random_deck: 'Baraja aleatoria',
      unlimited: 'Unlimited',
      one_copy: '60 · una copia',
    },
    modeHints: {
      random_deck: 'Una lista Standard nueva en cada duelo. No llevas baraja.',
      unlimited: 'Tus cartas. Tres copias, sin banlist de casa.',
      one_copy: 'Tus cartas. Sesenta en el Main, una de cada nombre.',
    },
  },
  tournament: {
    kicker: 'Eliminación directa',
    title: 'Torneos',
    history: 'Historial de torneos',
    historyLead: 'Los últimos 10 torneos terminados. Abre uno para ver el cuadro y las barajas.',
    empty: 'Todavía no hay torneos terminados.',
    upcoming: 'La inscripción abre a las {time}',
    countdown: 'Empieza en {time}',
    waitHours: 'Faltan {n} horas para el próximo torneo.',
    waitHour: 'Falta 1 hora para el próximo torneo.',
    waitMinutes: 'Faltan {n} minutos para el próximo torneo.',
    waitMinute: 'Falta 1 minuto para el próximo torneo.',
    waitSoon: 'El próximo torneo está por empezar.',
    waitJoin: 'Inscríbete y juega por las recompensas.',
    joinWindow: 'Podrás inscribirte en los últimos 30 minutos. El botón aparece aquí.',
    registration: 'Inscripción abierta',
    openTitle: 'La inscripción está abierta',
    openBody: 'Ya puedes inscribirte al próximo torneo. Quedan unos {minutes} minutos. Inscríbete y juega por las recompensas.',
    notice2hTitle: 'Faltan 2 horas',
    notice2hBody: 'El próximo torneo empieza en 2 horas.',
    notice1hTitle: 'Falta 1 hora',
    notice1hBody: 'El próximo torneo empieza en 1 hora.',
    notice5mTitle: 'Faltan 5 minutos',
    notice5mBody: 'El torneo empieza en 5 minutos. Inscríbete si todavía no lo has hecho.',
    notice1mTitle: 'Falta 1 minuto',
    notice1mBody: 'El torneo empieza en 1 minuto.',
    openBracket: 'Ver cuadro',
    sampleBadge: 'Prueba',
    registered: '{n} de {max} inscritos',
    join: 'Inscribirme',
    leave: 'Salir de la inscripción',
    joined: 'Ya estás inscrito. Esa baraja queda bloqueada hasta que termine el torneo.',
    pickTitle: 'Elige tu baraja',
    pickBody:
      'Esta baraja queda bloqueada hasta que termine el torneo. Puedes seguir usándola en otros duelos. Si sales de la inscripción, se desbloquea.',
    pickConfirm: 'Inscribirme con esta baraja',
    closedSoon: 'La inscripción cerró. Faltan menos de 30 segundos.',
    autoJoined: 'Te inscribimos con “{name}”, la baraja que usas en duelos.',
    live: 'Torneo en curso',
    sample: 'Cuadro de prueba. No es un torneo real.',
    spectate: 'Espectar',
    replay: 'Ver replay',
    play: 'Jugar mi duelo',
    rejoin: 'Volver a mi duelo',
    bye: 'Descansa',
    legend: 'Guía',
    markPlay: 'Ganó el duelo',
    markShow: 'Ganó en los 5 minutos',
    markTime: 'Ganó por tiempo',
    markNoShow: 'No entró a la sala',
    markBye: 'Descansa',
    versus: '{a} contra {b}',
    advanced: 'Pasó {name}',
    eighths: 'Octavos',
    quarters: 'Cuartos',
    semi: 'Semifinal',
    final: 'Final',
    champion: 'Campeón',
    podiumTitle: 'Salón de campeones',
    podiumLead: 'Los tres duelistas con más torneos ganados.',
    podiumWins: '{n} títulos',
    podiumWin: '1 título',
    podiumAria: 'Puesto {place}: {name}, {wins}',
    players: '{n} duelistas',
    duration: 'Tiempo total {time}',
    decks: 'Barajas',
    main: 'Principal',
    extra: 'Extra',
    waiting: 'Esperando la siguiente ronda',
    autosPaused: 'Los torneos automáticos están en pausa.',
    roundClock: 'Ronda {time}',
    yourMatch: 'Tu duelo está listo',
    callBody: '{name} es tu rival. Tienes {minutes} minutos para abrir el duelo.',
    callLater: 'Ahora no',
    pushPrompt:
      'Confirma el permiso en la barra de direcciones. Si no aparece, actívalo en el candado.',
    pushDeniedBrowser:
      'Los avisos están bloqueados. Actívalos en el candado de la barra de direcciones.',
    errors: {
      closed: 'Los torneos están en pausa.',
      full: 'El cupo está lleno.',
      busy: 'Ya estás en un duelo o en una cola.',
      deck: 'Esa baraja no se puede usar.',
      banlist: 'Esa baraja no cumple la lista.',
      unowned: 'Esa baraja usa cartas que no tienes.',
      not_open: 'La inscripción no está abierta.',
      closed_soon: 'La inscripción cerró a falta de 30 segundos.',
    },
  },
  seasonReward: {
    final: 'Terminó la temporada. Quedaste en {league} y recibiste {n} sobres.',
    start: 'Empezó una nueva temporada. Te dimos un sobre de Metal Raiders.',
  },
  level: {
    title: 'Nivel de cuenta',
    lead:
      'Juega duelos para ganar XP. Tu liga clasificatoria es aparte y no cambia esto.',
    chip: 'Nv {n}',
    bar: '{into} / {need} XP',
    max: 'Nivel máximo',
    kicker: 'Servidor',
    loading: 'Cargando niveles…',
    board: 'Top de nivel',
    boardEmpty: 'Juega duelos para ganar XP y aparecer aquí.',
    place: 'Puesto {n} en el servidor',
    viewLadder: 'Ver el top de nivel',
    nextCoins: 'Siguiente: {n} monedas',
    nextPack: 'Siguiente: 1 sobre',
    nextBoth: 'Siguiente: 1 sobre y {n} monedas',
    xpGain: '+{n} XP',
    xpProgress: 'Progreso de nivel',
    levelUp: 'Nivel {n}',
    grantCoins: '+{n} monedas',
    grantPack: '1 sobre',
    grantBoth: '1 sobre y {n} monedas',
  },
  aiWins: {
    kicker: 'Vs IA',
    lead:
      'Cada dificultad de la CPU desde Difícil tiene su escalera. Fácil y Normal no entran. Solo cuentan las victorias terminadas de esta temporada.',
    rewardTitle: 'Premio de la escalera vs CPU',
    rewardPlace: 'Puesto',
    rewardRange: '1 a {n}',
    rewardNote:
      'Se envía al buzón cuando termina la temporada, según tus victorias contra la CPU. Quien empata el puesto {n} también entra. Difícil, Experto y Maestro pagan por separado.',
    loading: 'Cargando victorias…',
    board: 'Victorias',
    empty: 'Gana un duelo vs IA en {name} para aparecer aquí.',
    one: '1 victoria',
    many: '{n} victorias',
    place: 'Puesto {n} en el servidor',
  },
  auth: {
    loginTitle: 'Entrar',
    loginLead: 'Usa tu correo o tu nombre de usuario. Necesitas una cuenta para usar Dueling Chaos.',
    registerTitle: 'Crear cuenta',
    registerLead:
      'Un correo de Gmail, Outlook o Hotmail, un nombre público y una contraseña. ' +
      'El correo es para entrar y para restablecer la contraseña si la pierdes.',
    identifier: 'Correo o usuario',
    loginPlaceholder: 'tu@correo.com o usuario',
    email: 'Correo',
    username: 'Usuario',
    password: 'Contraseña',
    passwordHint: 'Al menos 4 caracteres',
    showPassword: 'Mostrar contraseña',
    hidePassword: 'Ocultar contraseña',
    signIn: 'Entrar',
    createAccount: 'Crear cuenta',
    noAccount: '¿Aún no tienes cuenta?',
    goRegister: 'Crea una',
    haveAccount: '¿Ya tienes cuenta?',
    goLogin: 'Entrar',
    forgotLink: '¿Olvidaste tu contraseña?',
    forgotTitle: 'Restablecer contraseña',
    forgotLead:
      'Escribe el correo de tu cuenta. Si coincide, te enviamos un enlace que funciona 30 minutos.',
    forgotSend: 'Enviar enlace',
    forgotSent:
      'Si ese correo tiene una cuenta, enviamos un enlace. Caduca en 30 minutos.',
    resetTitle: 'Elige una contraseña nueva',
    resetLead:
      'Este enlace funciona una sola vez. Al guardar, las otras sesiones de esta cuenta se cierran.',
    resetSave: 'Guardar contraseña',
    resetMissing: 'Este enlace no trae un código. Pide uno nuevo.',
    newPassword: 'Contraseña nueva',
    confirmPassword: 'Confirma la contraseña',
    logout: 'Cerrar sesión',
    signedIn: 'Sesión de {name}',
    errors: {
      email_domain:
        'Usa un correo de Gmail, Outlook o Hotmail. Lo guardamos para entrar ' +
        'y para restablecer la contraseña.',
      email_taken: 'Ese correo ya está registrado.',
      username_taken: 'Ese nombre de usuario ya está ocupado.',
      username_cooldown: 'Puedes cambiar tu nombre de nuevo en 30 días.',
      invalid_credentials: 'Correo, usuario o contraseña incorrectos.',
      validation: 'Revisa los campos e inténtalo de nuevo.',
      rate_limited: 'Demasiados intentos. Espera un minuto e inténtalo de nuevo.',
      database_unavailable:
        'El servidor no alcanza la base de datos. Arranca Postgres local o usa el sitio en línea.',
      network: 'No se pudo alcanzar el servidor.',
      expired: 'Tu sesión terminó. Entra de nuevo.',
      forgot_limited:
        'Demasiados correos de restablecimiento desde esta red. Espera una hora e inténtalo de nuevo.',
      reset_invalid: 'Este enlace no sirve o ya caducó. Pide uno nuevo.',
      password_mismatch: 'Las contraseñas no coinciden.',
    },
  },
  chat: {
    show: 'Chat',
    global: {
      title: 'Chat global',
      tab: 'Global',
      placeholder: 'Mensaje...',
      send: 'Enviar',
      show: 'Chat global',
      hide: 'Ocultar chat',
      online: '{n} en línea',
      expand: 'Ampliar chat',
      medium: 'Tamaño medio',
      full: 'Pantalla completa',
      shrink: 'Tamaño normal',
      resize: 'Arrastra para cambiar el tamaño del chat',
      move: 'Arrastra para moverlo',
      mentionList: 'Duelistas en línea',
      mentionNone: 'Nadie más está en línea',
      mentionMiss: 'Ese duelista no está en línea',
      profile: 'Perfil público de {name}',
      latest: 'Al final',
      muteOn: 'Silenciaste a {name}. Sus mensajes ya no aparecen para ti.',
      muteOff: 'Vuelves a ver los mensajes de {name}.',
      muteAlready: 'Ya silenciaste a {name}. Escribe /unmute {name} para volver a verlo.',
      unmuteAlready: '{name} no está silenciado.',
      muteSelf: 'No puedes silenciarte.',
      muteMissing: 'Nadie usa ese nombre.',
      muteUsage: 'Escribe /mute y el nombre. Para volver a verlo, /unmute y el nombre.',
      muteFail: 'No se pudo cambiar el silencio. Inténtalo de nuevo.',
    },
    duel: {
      tab: 'Duelo',
    },
    dm: {
      close: 'Cerrar el chat con {name}',
      placeholder: 'Mensaje para {name}',
      notFriends: '{name} no está en tu lista de amigos.',
      failed: 'No se pudo enviar el mensaje.',
    },
  },
  friends: {
    kicker: 'Cuenta',
    title: 'Amigos',
    lead: 'Agrega a un duelista por su nombre exacto. El chat y las invitaciones a sala son solo entre amigos.',
    back: 'Inicio',
    add: 'Agregar',
    addLabel: 'Nombre',
    loading: 'Cargando amigos…',
    loadError: 'No se pudieron cargar los amigos. Inténtalo de nuevo.',
    empty: 'Todavía no tienes amigos.',
    incoming: 'Solicitudes',
    outgoing: 'Enviadas',
    list: 'Amigos',
    accept: 'Aceptar',
    decline: 'Rechazar',
    cancel: 'Cancelar',
    remove: 'Eliminar',
    chat: 'Chat',
    invite: 'Duelo directo',
    sent: 'Solicitud enviada a {name}.',
    accepted: 'Tú y {name} ya son amigos.',
    acceptedMany: '{n} duelistas aceptaron tu solicitud.',
    presence: {
      online: 'En línea',
      in_duel: 'En duelo',
      offline: 'Desconectado',
    },
    requestIncoming: '{name} te envió una solicitud de amistad.',
    pendingBadge: '{n} solicitudes de amistad',
    inviteIncoming: '{name} te invitó a una sala privada.',
    inviteAccept: 'Entrar',
    inviteDecline: 'Ahora no',
    inviteDeclined: '{name} rechazó la sala.',
    errors: {
      invalid_username: 'Ese nombre no es válido.',
      user_not_found: 'Nadie usa ese nombre.',
      cannot_friend_self: 'Ese es tu propio nombre.',
      already_friends: 'Ya son amigos.',
      request_pending: 'Esa solicitud ya está en espera.',
      friend_cap: 'La lista de amigos está llena.',
      request_cap: 'Hay demasiadas solicitudes en espera.',
      not_friends: 'No son amigos.',
      request_missing: 'Esa solicitud ya no está.',
      rate_limited: 'Demasiados intentos. Espera un minuto.',
      database_unavailable: 'Amigos no está disponible ahora.',
      network: 'No se pudo alcanzar el servidor.',
      friends_failed: 'No se pudo actualizar. Inténtalo de nuevo.',
    },
  },
  profile: {
    title: 'Perfil',
    lead: 'Lo que ven los demás: tu nombre, tu retrato, tu liga, tu récord, tu tiempo jugado y las copias que fijas.',
    account: 'Cuenta',
    name: 'Nombre',
    nameHint:
      'Este nombre es el que ven en el chat y en los duelos en línea. Las líneas del chat pasan a mostrar el nombre nuevo. Puedes cambiarlo una vez cada 30 días.',
    nameCooldown: 'Puedes cambiar tu nombre de nuevo el {date}.',
    placeholder: 'Jugador',
    save: 'Guardar',
    saved: 'Guardado',
    tabs: {
      you: 'Tú',
      case: 'Vitrina',
      look: 'Apariencia',
    },
    public: {
      view: 'Ver tu página pública',
      edit: 'Editar tu vitrina',
      loading: 'Cargando a este duelista…',
      missing: 'Nadie usa ese nombre.',
      rateLimited: 'Demasiadas búsquedas seguidas. Espera un minuto y vuelve a abrir el perfil.',
      unavailable: 'No se pudo cargar este perfil. Inténtalo de nuevo.',
      online: 'Duelos en línea',
      rankedPlace: 'Clasificatoria #{n}',
      levelPlace: 'Top de nivel #{n}',
      aiPlace: '{name} #{n}',
      betaPlayer: 'Beta Player',
      betaTitle: 'Terminó la colocación de la temporada beta en {league}',
      record: '{wins}–{losses}',
      recordDraws: '{wins}–{losses}–{draws}',
      noDuels: 'Sin duelos',
      historyTitle: 'Duelos',
      historyEmpty: 'Todavía no hay duelos.',
      replay: 'Repetir',
      modes: {
        ai: 'contra la CPU',
        pvp_casual: 'Casual contra {name}',
        pvp_ranked: 'Clasificatoria contra {name}',
        pvp_event: 'Evento contra {name}',
      },
      results: {
        win: 'Victoria',
        loss: 'Derrota',
        draw: 'Empate',
      },
      mute: 'Silenciar',
      unmute: 'Silenciado',
      muteTitle: 'Sus mensajes dejan de aparecer solo para ti',
      unmuteTitle: 'Toca para volver a ver sus mensajes',
      playTime: 'Tiempo jugado: {time}',
      playMinutes: '{n} min',
      playHours: '{n} h',
      playHoursMinutes: '{h} h {m} min',
    },
    showcase: {
      title: 'Vitrina de foils',
      lead:
        'Fija hasta seis copias de tu álbum. La primera es la pieza ' +
        'central. Los demás duelistas la ven en tu página pública.',
      publicLead: 'Copias que este duelista eligió mostrar.',
      emptyOwn: 'Tu vitrina está vacía. Toca un hueco y elige una copia.',
      emptyPublic: 'Este duelista todavía no fijó ninguna copia.',
      editHint:
        'Toca una carta o un número para cambiar esa copia. Si tienes varias copias de la misma carta y rareza, cada una puede ocupar un hueco.',
      allPinned: 'Todas las copias de esta rareza ya están en la vitrina.',
      pick: 'Elige una copia',
      search: 'Busca en tu álbum',
      needAlbum: 'Abre sobres para tener copias que mostrar.',
      clear: 'Quitar este hueco',
      prev: 'Anterior',
      next: 'Siguiente',
      page: '{from}–{to} · {page}/{pages}',
    },
    avatar: {
      title: 'Retrato',
      photo: 'Foto del chat',
      random: 'Aleatorio',
      reset: 'Restablecer',
      artTitle: 'Arte',
      framesTitle: 'Marco',
      frames: {
        gold: 'Oro',
        silver: 'Plata',
        obsidian: 'Obsidiana',
        ivory: 'Marfil',
        crimson: 'Carmesí',
        azure: 'Azul',
        bronze: 'Bronce',
        emerald: 'Esmeralda',
        'last-call': 'Última llamada',
        'league-duelist': 'Duelista',
        'league-challenger': 'Retador',
        'league-champion': 'Campeón',
        'league-king': 'Rey de los Juegos',
      },
      leagueHint:
        'Llega a una liga en clasificatoria para desbloquear su marco. Es tuyo para siempre.',
    },
    look: {
      title: 'Apariencia del duelo',
      lead: 'El tapete y la funda que llevas a vs IA y a los duelos en línea.',
    },
  },
  rank: {
    title: 'Clasificatoria',
    kicker: 'Temporada',
    lead: 'La partida rápida es clasificatoria. Las salas privadas y vs IA no cambian tu liga.',
    loading: 'Cargando tu liga…',
    loadError: 'No se pudo cargar la escalera.',
    retry: 'Reintentar',
    back: '← Volver al inicio',
    play: 'Jugar clasificatoria',
    viewLadder: 'Ver escalera',
    seasonSince: 'Temporada desde {date}',
    you: 'Tú',
    placement: 'Colocación',
    placementLeft: 'Colocación: quedan {n} duelos',
    lpCount: '{lp} / 100 LP',
    lpBare: '{lp} LP',
    lpLine: '{name} · {lp} LP ({delta})',
    lpProgress: 'Puntos de liga',
    promoted: '¡Ascenso!',
    promoPack: '+1 sobre',
    promoPacks: '+{n} sobres',
    seasonPacks: '+{n} sobres al cierre',
    rewardsTitle: 'Premios de liga',
    rewardsLead:
      'Al cerrar la temporada, quien ya terminó la colocación recibe Master Packs según la liga en la que quedó.',
    rewardsLeague: 'Liga',
    rewardsPrize: 'Premio',
    rewardPack: '1 Master Pack',
    rewardPacks: '{n} Master Packs',
    rewardsClimb:
      'Subir de liga da {league} Master Packs en el momento. Subir de división da {division} Master Pack. La funda, el tapete y el marco de esa liga se quedan.',
    cosmeticsUnlocked: 'Nuevo set de la liga {league}',
    cosmeticsWhere: 'Funda, tapete y marco. Equípalos en tu perfil.',
    demoted: 'Descenso',
    board: 'Esta temporada',
    boardEmpty: 'Gana duelos clasificatorios para aparecer aquí.',
    prev: 'Anterior',
    next: 'Siguiente',
    pager: '{page} / {pages}',
    pagerLabel: 'Páginas de la escalera',
    prizesLead: 'Qué se entrega al cerrar la temporada.',
    tabs: {
      ranked: 'Clasificatoria',
      level: 'Nivel',
      prizes: 'Premios',
      event: 'Evento',
    },
    leagues: {
      duelist: 'Duelista',
      challenger: 'Retador',
      champion: 'Campeón',
      king: 'Rey de los Juegos',
    },
  },
  home: {
    title: 'Dueling Chaos',
    kicker: '',
    vsAi: 'Duelo vs IA',
    vsAiHint: 'Tu baraja contra la CPU.',
    vsAiPick: 'Elige la dificultad de la CPU',
    vsAiStart: 'Empezar duelo',
    vsAiCancel: 'Cancelar',
    vsAiTag: 'Solo',
    playOnline: 'Jugar en línea',
    onlineHint: 'Partida rápida clasificatoria contra otro duelista.',
    casual: 'Cola casual',
    casualTag: 'Sin liga',
    casualHint: 'Tu liga no se mueve.',
    eventTag: 'Evento',
    eventHint: 'Una cola semanal. Una victoria paga 7 monedas; una derrota o un empate terminados pagan 5, igual que clasificatoria. Al cerrar, Master Packs por porcentaje de quienes ganaron: 20 el top 1%, 15 el resto del top 10%, 8 el resto del top 25%, 4 el resto del top 50% y 2 el resto.',
    eventRankHint: 'El ranking está en {rank}, en {tab}.',
    queueWaiting: '{n} en cola',
    queueClosed: 'Clasificatoria en pausa',
    rankedOffer: 'Juega una clasificatoria y te damos {n} monedas.',
    onlineTag: 'PvP',
    rank: 'Mejores jugadores',
    rankTag: 'Escaleras',
    rankHint: 'Las ligas de esta temporada, el nivel y las victorias vs IA desde Difícil.',
    rooms: 'Salas privadas',
    roomsHint: 'Mira las salas abiertas o crea una. No es clasificatoria.',
    roomsTag: 'Casual',
    watch: 'Ver duelos',
    watchTag: 'En vivo',
    watchHint: 'Especta partidas clasificatorias y salas privadas. Las manos quedan ocultas.',
    packs: 'Sobres',
    packsHint: 'Abre sobres y aumenta tu colección.',
    packsTag: 'Sobres',
    missions: 'Misiones',
    missionsTag: 'Recompensas',
    missionsHint: 'Tareas diarias y partidas clasificatorias, por monedas y un sobre de tienda.',
    collection: 'Colección',
    collectionHint: 'El álbum: lo que tienes y lo que te falta.',
    collectionTag: 'Álbum',
    deckBuilder: 'Baraja',
    deckHint: 'Arma y guarda la lista que llevas al duelo.',
    deckTag: 'Preparar',
    using: 'Tu baraja: {name}',
    playDeck: 'Jugar con',
    deckNotReady: ' (no lista)',
    changelog: 'Novedades',
    changelogHint: 'Lo que cambió en el juego últimamente.',
    banlistHint: 'Máximo 1 o 2 copias. La lista cambia según el meta. Clasificatoria, cola casual, salas y contra la CPU.',
    popularHint: 'Qué cartas aparecen más, con cuáles viajan, y cuántas veces ganan esas barajas.',
    faqHint: 'Cómo inscribirse al torneo, la banlist y los límites diarios de recompensa.',
    cardsRestoredTitle: 'Tus cartas',
    cardsRestoredOne:
      'Te devolvimos 1 carta que tenías antes del reset. Ya está en tu colección, sumada a las que conseguiste después. No habrá más resets. Gracias por jugar.',
    cardsRestoredMany:
      'Te devolvimos {n} cartas que tenías antes del reset. Ya están en tu colección, sumadas a las que conseguiste después. No habrá más resets. Gracias por jugar.',
    letterKicker: 'De los desarrolladores',
    letterTitle: 'Un mensaje',
    letterThanks:
      'Primero que todo, quiero agradecerles a todos por el apoyo y por jugar tanto.',
    letterTesting:
      'Quiero comunicarles que ya se está testeando **Metal Raiders**. El avance de las cartas va en un **90%**, pero les pido paciencia, ya que hay que trabajar en otras cosas como las recompensas, el balanceo de las clasificatorias y otros sistemas que quiero que estén afinados para el lanzamiento de Metal Raiders.',
    letterRewards:
      'Sé que actualmente el juego se encuentra en un estado un tanto loco, con muchas copias de cartas fuertes, pero que sepan que es intencional: la idea de esta etapa era testear el juego y arreglar bugs para tener una buena base antes de seguir con las actualizaciones. Por eso las recompensas, tanto en clasificatoria como contra la CPU, son altísimas. Así se pueden abrir muchos sobres y tener muchas cartas en pocas horas de juego. Esto ha permitido que todos puedan probar todas las cartas y reportar bugs. Gracias a todos por eso.',
    letterBanlist:
      'Sé que se ha hablado mucho de una banlist, pero mi idea es que tengamos algo diferente, donde el **RNG**, el gran pool de cartas y recompensas mucho más bajas que las actuales controlen el balance del juego. Si eso no funciona, entonces ahí tendremos que empezar a pensar en una banlist.',
    letterBreak:
      'Vamos a tomarnos uno o dos días de descanso y continuaremos el trabajo. Espero su comprensión y, otra vez, gracias.',
    noticeCollect: 'Recoger',
    noticeExpand: 'Expandir',
    keepAllKicker: 'Aviso',
    keepAllTitle: 'Ya no hay resets',
    keepAllLead:
      'No va a haber más resets de absolutamente nada. Se conservan las **cartas**, las **monedas**, los **sobres**, todo.',
    keepAllRank:
      'Lo único que se reinicia son los [[rankings]] de cada [[temporada]].',
    nextSetKicker: 'Siguiente set de cartas',
    nextSetTitle: 'Spell Ruler',
    nextSetArtAlt: 'Sobre de Spell Ruler',
    lastCall:
      'Última llamada. Solo cuentan las partidas clasificatorias PVP terminadas. Contra la CPU no cuenta. {current} de {target}.',
    lastCallOpen: 'Ver los premios',
    nextSetLead:
      'Estamos **enfocados** trabajando en **Spell Ruler**. Aproximadamente en **3 semanas** estará listo.',
    nextSetReset:
      'Cada vez que se libere una expansión o un set de cartas nuevas, [[se reinician]] [[las cartas que obtuviste]], tus [[monedas]], tu [[liga]] y tu [[nivel]]. Tu **colección no se reinicia**. El reinicio evita que los jugadores con más y mejores cartas acaparen el top, da la oportunidad a los jugadores nuevos de escalar y fomenta la variedad en las barajas.',
    nextSetRewards:
      'Habrá **recompensas** para todos los que **participaron y ayudaron** a mejorar el juego, y también para **los que más jugaron**. Quienes quedaron en el top de la **clasificatoria** y en el top **contra la CPU** reciben recompensas **cosméticas** y **sobres**.',
    pollTitle: '¿Reiniciar la colección?',
    pollLead: 'Vota si la colección también debería reiniciarse cuando llegue un set nuevo.',
    pollYes: 'Sí',
    pollNo: 'No',
    pollTally: '{yes} sí · {no} no',
    pollSaved: 'Voto guardado. Puedes cambiarlo.',
    pollFolded: 'Votaste {vote}. Toca para cambiarlo.',
    pollRewardTitle: 'Recompensas para el top',
    pollRewardLead:
      'Escribe las recompensas que quieres para quienes queden arriba después del reinicio. Pueden ser cosméticas o cartas.',
    pollRewardPlaceholder: 'Un tapete, fundas, una carta concreta…',
    pollRewardSend: 'Enviar sugerencia',
    pollRewardThanks: 'Recibimos tu sugerencia.',
    pollError: 'No se pudo guardar. Inténtalo de nuevo.',
    pollLoadError: 'No se pudo cargar la encuesta.',
    pollRate: 'Espera un momento antes de enviar otra vez.',
    banPollTitle: '¿Cartas prohibidas?',
    banPollLead:
      'Hoy la lista solo limita cartas: puedes jugar 1 copia. Una carta prohibida no se puede jugar, o sea 0 copias en la baraja. ¿Las quieres ya, o por ahora seguimos solo con cartas limitadas?',
    banPollForbidden: 'Quiero cartas prohibidas',
    banPollLimited: 'Por ahora solo limitadas',
    banPollResults: 'Votos hasta ahora',
    banPollCount: '{count} · {pct}%',
    banPollTally: '{forbidden} quieren prohibidas · {limited} solo limitadas',
    banPollEmpty: 'Todavía no hay votos.',
    banPollCommentTitle: 'Comentario adicional',
    banPollCommentLead: 'Si quieres, agrega algo más sobre las cartas prohibidas.',
    banPollCommentPlaceholder: 'Tu comentario…',
    banPollCommentSend: 'Enviar comentario',
    banPollCommentThanks: 'Recibimos tu comentario.',
  },
  discord: {
    join: 'Únete a Discord',
  },
  support: {
    tip: 'Apoyar',
    title: 'Apoyar',
    lead: 'Estos paquetes suman monedas a tu cuenta. Un sobre de tienda cuesta 20 monedas.',
    rowCoins: '{n} monedas',
    rowPacks: '{n} sobres',
    other: 'Donar otro monto',
    otherNote: 'Tú eliges la cantidad. Esa donación no da monedas.',
    signIn: 'Entra para recibir las monedas',
    close: 'Cerrar',
    failed: 'PayPal no se abrió. Prueba de nuevo.',
  },
  thanks: {
    kicker: 'Gracias',
    title: 'La Maga Oscura te manda',
    accent: 'un beso',
    lead: 'Tu apoyo mantiene el duelo en pie.',
    coins: 'Sumamos {n} monedas a tu cuenta.',
    coinsLater: 'Si ya pagaste, las monedas entran en tu cuenta.',
    back: 'Volver al inicio',
    artAlt: 'La Maga Oscura guiñando un ojo y mandando un beso',
  },
  pwa: {
    title: 'Instalar la app',
    lead: 'Instala Dueling Chaos en este dispositivo. Se abre a pantalla completa, como una app.',
    hint: 'Agrega un icono en la pantalla de inicio o el escritorio. Los duelos llenan la pantalla.',
    install: 'Instalar Dueling Chaos',
    installed: 'Este dispositivo ya tiene Dueling Chaos instalado.',
    ios: 'En iPhone o iPad: toca Compartir y luego Añadir a pantalla de inicio.',
    manual: 'Usa el menú del navegador para instalar este sitio como app.',
  },
  push: {
    title: 'Avisos del torneo',
    body: 'Los mismos avisos del torneo pueden llegar con Dueling Chaos cerrado: a las 2 horas, a la 1 hora, cuando abre la inscripción, a los 5 minutos, al minuto y cuando tu duelo está listo.',
    enable: 'Activar avisos',
    later: 'Ahora no',
  },
  changelog: {
    kicker: 'Actualizaciones',
    title: 'Novedades',
    lead: 'Notas para duelistas. Cambia el idioma cuando quieras desde el menú de la barra de arriba.',
    dialogLead: 'Cambios de los últimos 3 días.',
    dismiss: 'Entendido',
    open: 'Ver todas',
    pending: 'Novedades pendientes',
    back: '← Volver al inicio',
  },
  meta: {
    kicker: 'Esta temporada',
    title: 'Cartas más usadas',
    lead: 'Cartas que los duelistas llevan en esta temporada cuando empieza un duelo. El uso es la parte de las barajas. Esa barra se llena contra la carta más jugada. Las victorias cuentan solo duelos terminados. El número al lado es cómo se movieron los últimos 7 días de esta temporada frente a los 7 anteriores. Toca una carta para ver con cuáles viaja.',
    back: '← Volver al inicio',
    modes: 'Modo',
    all: 'Todas',
    ranked: 'Clasificatoria',
    top: 'Top',
    topHint: 'Solo Campeón y Rey de los Juegos, en clasificatoria.',
    casual: 'Casual',
    ai: 'Contra la CPU',
    sort: 'Orden',
    sortUsage: 'Más usadas',
    sortWin: 'Victorias',
    winFloor: 'Las victorias ordenan cartas con al menos {n} duelos terminados.',
    decks: '{n} barajas',
    usage: '{n}% de las barajas',
    usageShort: 'Uso',
    win: '{n}% de victorias',
    winShort: 'Victorias',
    winEmpty: 'Sin duelos terminados',
    sample: '{n} duelos',
    copies: '{n} copias por baraja',
    copiesSplit: '1× {a}% · 2× {b}% · 3× {c}%',
    deltaUsage: 'Últimos 7 días {n} frente a los 7 anteriores',
    deltaWin: 'Últimos 7 días {n} frente a los 7 anteriores',
    with: 'Compañeras',
    withClose: 'Cerrar',
    withSample: '{n} barajas llevan esta carta.',
    withLead: 'El porcentaje es cuántas de esas barajas también llevan la otra carta.',
    withShare: '{n}% de las barajas que llevan esta',
    withEmpty: 'Todavía no hay cartas que viajen con esta en esta temporada.',
    empty: 'Todavía no hay duelos en esta temporada.',
    loadError: 'No se pudo cargar la lista.',
    retry: 'Reintentar',
    loading: 'Cargando',
    place: 'Puesto {n}',
  },
  banlist: {
    kicker: 'Todos los duelos',
    title: 'Banlist',
    lead: 'Límites de copias en clasificatoria, la cola casual, las salas privadas y contra la CPU. Tu baraja también los sigue. La lista es permanente y va cambiando según el meta.',
    limited1: 'Limited — máximo 1',
    limited2: 'Semi-Limited — máximo 2',
    max: 'Máximo {n}',
    back: '← Volver al inicio',
  },
  banlistReward: {
    kicker: 'Duelista nuevo',
    title: 'Elige una carta de la banlist',
    lead: 'Elige una carta. Tienes {n} elecciones abiertas.',
    leadOne: 'Elige una carta. Esta elección está abierta.',
    owned: 'Tienes {n}',
    max: 'Máximo {n} en la baraja',
    confirm: '¿Agregar {name}?',
    confirmBody: 'Una copia Common entra a tu colección.',
    add: 'Agregar',
    adding: 'Agregando…',
    back: 'Volver',
    later: 'Después',
    profileChoose: 'Elegir carta de la banlist',
    profileLeft: '{n} para elegir',
    profileNext: 'La siguiente carta de la banlist se desbloquea en el nivel {n}.',
    gameOver: 'Puedes elegir una carta de la banlist.',
    gameOverChoose: 'Elegir carta',
    error: 'No se pudo agregar esa carta. Inténtalo de nuevo.',
    empty: 'La banlist está vacía por ahora.',
  },
  faq: {
    kicker: 'Ayuda',
    title: 'Preguntas frecuentes',
    lead: 'Los torneos automáticos, la banlist y los límites diarios de recompensa.',
    back: '← Volver al inicio',
    items: {
      tournamentJoin: {
        q: '¿Cómo me inscribo al torneo?',
        a: 'La inscripción no está abierta todo el día. Abre **30 minutos** antes de la hora. En ese momento, la tarjeta del torneo muestra el botón **Inscribirme**. Eliges la baraja y quedas dentro.\n\nEsa tarjeta está en Inicio, en Duelo y en Torneos. Antes de los 30 minutos el botón no está: la tarjeta dice cuánto falta. Si tocas el aviso de los **5 minutos** o del **último minuto**, también se abre la inscripción.',
      },
      tournamentWhen: {
        q: '¿A qué hora son los torneos?',
        a: 'Salen cada **3 horas**. El contador de la tarjeta usa tu reloj. La inscripción abre en los últimos **30 minutos**.\n\nSi estás en el sitio cuando abre, sale un aviso. La campana de la tarjeta puede avisarte también con el sitio cerrado, si aceptas el permiso. Toca la campana tachada para apagar esos avisos.',
      },
      tournamentField: {
        q: '¿Cuántas plazas hay y cuándo arranca?',
        a: 'Son **8** plazas, de eliminación directa y un duelo por ronda. Arranca apenas se llenan, o a la hora si no se llenaron. Con menos de **4** duelistas se cancela y nadie cobra.\n\nEstos duelos no mueven tu liga.',
      },
      tournamentDeck: {
        q: '¿Qué baraja uso en el torneo?',
        a: 'Al inscribirte eliges una. Esa baraja no se puede editar hasta que termine el torneo o salgas de la inscripción. Reciclar queda cerrado mientras estés inscrito. Puedes seguir usándola en otros duelos.\n\nLa inscripción cierra **30 segundos** antes de empezar. Si la lista de barajas sigue abierta en ese momento, entras con la baraja que usas en duelos.',
      },
      tournamentPlay: {
        q: '¿Qué hago cuando me toca jugar?',
        a: 'Cuando tu duelo está listo, te llega un aviso. Tienes **5 minutos** para abrirlo. Si no entras y tu rival sí, él pasa. Cada ronda dura **40 minutos**.',
      },
      tournamentPrizes: {
        q: '¿Qué se gana en el torneo?',
        a: 'Los premios llegan a tu buzón cuando el torneo termina. Quien termina un duelo recibe un Master Pack.\n\nCon **5** o más, el cuadro es de 8: cuartos pagan **10** monedas, la semifinal **30**, el finalista **40** y el campeón **50**. Si arranca con **4**, la semifinal paga **20**, el finalista **30** y el campeón **40**. Rendirse en el primer duelo no paga.',
      },
      banlist: {
        q: '¿La banlist aplica a todos los duelos?',
        a: 'Sí. Vale en clasificatoria, en la cola casual, en las salas privadas y contra la CPU, incluida tu baraja. Las barajas de la CPU también la siguen, en Maestro incluido.',
      },
      banlistMeta: {
        q: '¿La banlist es permanente?',
        a: 'Sí. Ya no es temporal. La lista va a ir cambiando según el meta.',
      },
      rewardsLadder: {
        q: '¿La escalera de clasificatoria tiene un límite diario?',
        a: 'Sí. En Misiones, los primeros **10** duelos clasificatorios terminados del día llenan la escalera. Los pasos **1** a **9** pagan **3** monedas cada uno. El paso **7** también da un sobre de tienda, y el paso **10** da dos sobres y ninguna moneda. A partir del duelo 11, esa escalera ya no avanza hasta medianoche UTC. Salir de la partida no cuenta.',
      },
      rewardsMatch: {
        q: '¿Las monedas de un duelo clasificatorio tienen tope diario?',
        a: 'No. Una victoria paga **7** y una derrota o un empate terminados pagan **5**, todas las veces. Rendirse no paga.',
      },
      rewardsEvent: {
        q: '¿Qué pagan los duelos de la cola de evento?',
        a: 'Una victoria paga **7** monedas, y una derrota o un empate terminados pagan **5**, igual que clasificatoria. Rendirse no paga. Estos duelos no mueven tu liga. Al cerrar la semana, el porcentaje se cuenta entre quienes ganaron al menos un duelo y cobras una sola banda: **20** Master Packs el top 1%, **15** el resto del top 10%, **8** el resto del top 25%, **4** el resto del top 50% y **2** el resto. Un empate en victorias y derrotas en el corte cobra la banda de arriba.',
      },
      rewardsCall: {
        q: '¿El aviso de que alguien espera una clasificatoria tiene límite?',
        a: 'Paga **1** moneda extra, hasta **20** veces al día. Después el aviso sigue, pero esa moneda extra no. Se reinicia a medianoche UTC.',
      },
      rewardsDaily: {
        q: '¿Las misiones diarias y la carrera se reinician?',
        a: 'Sí, a medianoche UTC. Cada misión y cada meta de la carrera pagan **3** monedas. Completar **7** de las **10** misiones diarias da un sobre de tienda. Las misiones de colección no se reinician.',
      },
    },
  },
  dialog: {
    snoozeToday: 'No mostrar más hoy',
  },
  eventQueueDialog: {
    kicker: 'Esta semana',
    title: 'Cola de evento',
    lead:
      'Una cola rotativa a la vez. Las **victorias** van a un ranking público. Clasificatoria y casual no cambian.',
    duelPay:
      'Cada duelo terminado paga **7** monedas al ganar y **5** al perder o empatar, igual que clasificatoria. Rendirse no paga.',
    prizes:
      'Al cerrar la semana, el porcentaje se cuenta entre quienes ganaron al menos un duelo. Cobras una sola banda de Master Packs: **20** el top 1%, **15** el resto del top 10%, **8** el resto del top 25%, **4** el resto del top 50% y **2** el resto. Un empate en victorias y derrotas en el corte cobra la banda de arriba.',
    live: 'En vivo',
    play: 'Entrar a la cola',
    board: 'Ver el ranking',
    modes: {
      random_deck:
        'Cada duelo te da una lista Standard nueva. No eliges baraja.',
      unlimited:
        'Tus cartas. Tres copias de cualquier nombre, sin banlist de casa. 40–60 en el Main.',
      one_copy:
        'Tus cartas. Al menos 60 en el Main, y solo una copia de cada nombre.',
    },
  },
  lastCallDialog: {
    kicker: 'Evento',
    lead:
      'Durante dos semanas, las partidas clasificatorias PVP terminadas desbloquean un marco, un retrato, una funda, un tapete y un sobre promo. La Blue-Eyes promo se puede reciclar como cualquier otra copia.',
    foil:
      'El sobre trae un Blue-Eyes White Dragon en un foil al azar por encima de Super Rare.',
    rules:
      'También cuenta si pierdes. Contra la CPU, las salas privadas y dejar la partida no cuentan.',
  },
  missions: {
    kicker: 'Diario',
    title: 'Misiones',
    tabs: {
      daily: 'Diarias',
      runner: 'Carrera',
      ranked: 'Clasificatoria',
      collection: 'Colección',
      lastCall: 'Última llamada',
    },
    runner: {
      lead:
        'Las mismas cinco cada día, de la carrera de la cola. Cuenta en clasificatoria, casual y en la cola de evento. Cada una paga 3 monedas. Se reinician a medianoche UTC y no entran en el tablero de 10.',
      'runner-cards-5': 'Salta 5 cartas',
      'runner-cards-20': 'Salta 20 cartas hoy',
      'runner-cards-40': 'Salta 40 cartas hoy',
      'runner-steps-100': 'Llega a 100 pasos en una carrera',
      'runner-steps-400': 'Llega a 400 pasos en una carrera',
    },
    collection: {
      lead:
        'Estas misiones no se reinician. Cada peldaño se cobra una vez y cuenta las cartas que ya tienes. Los peldaños más difíciles también dan un sobre de tienda.',
      family: {
        total: 'Total',
        set: 'Sets',
        kind: 'Tipos',
        attribute: 'Atributos',
        race: 'Razas',
        foil: 'Rareza',
        playset: 'Tres copias',
      },
      total: 'Colecciona {n} cartas distintas',
      totalAll: 'Completa la colección',
      set: 'Colecciona {n} cartas de {set}',
      setAll: 'Completa {set}',
      kind: 'Colecciona {n} {kind}',
      attr: 'Colecciona {n} cartas de {attr}',
      attrAll: 'Completa {attr}',
      race: 'Colecciona {n} cartas de {race}',
      raceAll: 'Completa {race}',
      foil: 'Consigue {n} cartas {foil}',
      playset: 'Arma {n} grupos de 3 copias',
      kinds: {
        normal: 'monstruos normales',
        effect: 'monstruos de efecto',
        spell: 'cartas mágicas',
        trap: 'cartas de trampa',
        fusion: 'monstruos de fusión',
      },
      kindAll: {
        normal: 'Completa los monstruos normales',
        effect: 'Completa los monstruos de efecto',
        spell: 'Completa las cartas mágicas',
        trap: 'Completa las cartas de trampa',
        fusion: 'Completa los monstruos de fusión',
      },
      foils: {
        rare: 'Raras o mejores',
        super: 'Súper Raras o mejores',
        ultra: 'Ultra Raras o mejores',
        special: 'con impresión especial',
      },
      packWinOne:
        'Ese peldaño de colección dejó un sobre de tienda con tus sobres. Lo puedes abrir cuando quieras.',
      packWinMany:
        'Esos peldaños de colección dejaron {n} sobres de tienda con tus sobres. Los puedes abrir cuando quieras.',
    },
    lead:
      'Completa 7 de 10 para un sobre de tienda. Cada misión paga 3 monedas. Se reinician a medianoche UTC.',
    rankedLead:
      'Los pasos 1 a 9 pagan 3 monedas cada uno. El paso 7 da un sobre de tienda y el paso 10 da dos. Si abandonas la partida, ese paso no cuenta. Se reinicia a medianoche UTC.',
    rankedOne: 'Termina 1 partida clasificatoria',
    rankedMany: 'Termina {n} partidas clasificatorias',
    rankedPackWinLead:
      'Terminaste {n} partidas clasificatorias hoy. El sobre de tienda ya está con tus sobres y lo puedes abrir cuando quieras.',
    rankedPackWinMany:
      'Terminaste {n} partidas clasificatorias hoy. Los {packs} sobres de tienda ya están con tus sobres y los puedes abrir cuando quieras.',
    lastCallLead:
      'Termina partidas clasificatorias PVP durante estas dos semanas. Contra la CPU, las salas privadas y dejar la partida no cuentan. La Blue-Eyes promo se puede reciclar como cualquier otra copia.',
    lastCallClosed:
      'Última llamada está cerrada. Lo que no alcanzaste no se entrega.',
    lastCallFrozen: 'La lista está congelada.',
    lastCallUntil: 'Cierra el {date} UTC.',
    lastCall: {
      frame: 'Marco de avatar',
      portrait: 'Retrato de Blue-Eyes',
      sleeve: 'Funda de cartas',
      mat: 'Tapete',
      pack: 'Sobre promo: Blue-Eyes White Dragon',
    },
    toastRanked: 'La partida clasificatoria {n} está lista para recoger',
    back: '← Volver al inicio',
    empty: 'No hay misiones disponibles ahora.',
    loadError: 'No se pudieron cargar las misiones.',
    retry: 'Reintentar',
    claim: 'Recoger',
    claimAll: 'Recoger todo',
    claimCta: 'Reclamar',
    claimed: 'Recogida',
    progress: '{current} / {target}',
    remaining: 'Faltan {n} misiones para tu sobre',
    remainingOne: 'Falta 1 misión para tu sobre',
    packUnlocked: '¡Sobre desbloqueado!',
    packPrize: 'Sobre de tienda',
    packWinKicker: 'Recompensa',
    packWinTitle: '¡Ganaste un sobre!',
    packWinLead:
      'Completaste {n} misiones diarias. El sobre de tienda ya está con tus sobres y lo puedes abrir cuando quieras.',
    packWinOpen: 'Ir a sobres',
    packWinClose: 'Entendido',
    railHint: 'Cada paso te da 3 monedas extra',
    stepClaim: 'Recoger paso {n}',
    stepClaimed: 'Paso {n} recogido',
    stepDone: 'Misión {n} completa',
    stepTodo: 'Misión {n}',
    resetHint: 'Se reinicia en {h}h {m}m (medianoche UTC).',
    toastDone: 'Completaste: {name}',
    toastDoneMany: 'Completaste {n} misiones',
    toastHint: 'Ve a Misiones para reclamar la recompensa.',
    pendingBadge: '{n} por recoger',
    category: {
      presence: 'Jugar',
      skill: 'Habilidad',
      flavor: 'Duelo',
    },
    ids: {
      'play-1': 'Termina 1 duelo',
      'play-ai-1': 'Juega 1 duelo contra la CPU',
      'open-pack-1': 'Abre 1 sobre',
      'draw-15': 'Roba 15 cartas',
      'play-3': 'Termina 3 duelos',
      'play-ai-3': 'Juega 3 duelos contra la CPU',
      'xp-40': 'Gana 40 XP en duelos',
      'draw-40': 'Roba 40 cartas',
      'open-pack-2': 'Abre 2 sobres',
      'play-5': 'Termina 5 duelos',
      'xp-90': 'Gana 90 XP en duelos',
      'draw-80': 'Roba 80 cartas',
      'open-pack-5': 'Abre 5 sobres',
      'win-1': 'Gana 1 duelo',
      'win-lp-1': 'Gana 1 duelo bajando los Life Points a 0',
      'survive-2000-1': 'Gana 1 duelo conservando 2000 LP o más',
      'win-2': 'Gana 2 duelos',
      'win-ai-hard-1': 'Gana 1 duelo contra la CPU en Difícil o superior',
      'win-fast-1': 'Gana 1 duelo en 8 turnos o menos',
      'survive-2000-2': 'Gana 2 duelos conservando 2000 LP o más',
      'win-lp-2': 'Gana 2 duelos bajando los Life Points a 0',
      'win-4': 'Gana 4 duelos',
      'win-ai-hard-3': 'Gana 3 duelos contra la CPU en Difícil o superior',
      'win-fast-2': 'Gana 2 duelos en 8 turnos o menos',
      'survive-2000-4': 'Gana 4 duelos conservando 2000 LP o más',
      'win-lp-4': 'Gana 4 duelos bajando los Life Points a 0',
      'summon-8': 'Invoca 8 monstruos',
      'attack-10': 'Declara 10 ataques',
      'spell-5': 'Activa 5 Cartas Mágicas',
      'damage-2000': 'Inflige 2000 o más de daño de batalla en un mismo turno',
      'summon-20': 'Invoca 20 monstruos',
      'attack-25': 'Declara 25 ataques',
      'spell-15': 'Activa 15 Cartas Mágicas',
      'trap-6': 'Activa 6 Cartas de Trampa',
      'tribute-5': 'Invoca 5 monstruos por tributo',
      'fusion-1': 'Realiza 1 Invocación por Fusión',
      'damage-3500': 'Inflige 3500 o más de daño de batalla en un mismo turno',
      'summon-40': 'Invoca 40 monstruos',
      'attack-45': 'Declara 45 ataques',
      'spell-28': 'Activa 28 Cartas Mágicas',
      'trap-12': 'Activa 12 Cartas de Trampa',
      'tribute-10': 'Invoca 10 monstruos por tributo',
      'fusion-3': 'Realiza 3 Invocaciones por Fusión',
      'damage-5000': 'Inflige 5000 o más de daño de batalla en un mismo turno',
    },
  },
  settings: {
    title: 'Ajustes',
    lead: 'Cómo se juega la app y cómo se ven los menús en este dispositivo.',
    tabs: {
      play: 'Juego',
      look: 'Menús',
      dev: 'Dev',
    },
    appearance: 'Apariencia',
    theme: 'Tema',
    themeHint: 'Las pantallas de menú usan esto. El tablero del duelo sigue oscuro.',
    fullscreen: 'Pantalla completa',
    fullscreenHint:
      'Oculta las barras del navegador. En un duelo, también se oculta el menú de arriba para que el tablero sea más grande. Esc para salir.',
    pushTitle: 'Avisos del torneo',
    pushHint: 'La cuenta atrás y el aviso de duelo listo, aunque la app esté cerrada.',
    pushEnable: 'Activar avisos',
    pushDisable: 'Desactivar avisos',
    pushOn: 'Este dispositivo recibe los avisos del torneo con la app cerrada.',
    pushMuted: 'Los avisos del torneo están apagados en este dispositivo.',
    pushDenied: 'Los avisos están bloqueados. Actívalos para Dueling Chaos en los ajustes de Android.',
    pushUnsupported: 'Este navegador no puede mostrar avisos con la app cerrada.',
    light: 'Claro',
    dark: 'Oscuro',
    accent: 'Color de acento',
    accentHint: 'Se usa en la página activa, los chips y los resaltados.',
    custom: 'Color personalizado',
    preview: 'Vista previa',
    presets: {
      gold: 'Oro',
      orange: 'Naranja',
      coral: 'Coral',
      rose: 'Rosa',
      pink: 'Rosado',
      violet: 'Violeta',
      indigo: 'Índigo',
      blue: 'Azul',
      cyan: 'Cian',
      teal: 'Verde azulado',
      green: 'Verde',
      silver: 'Plata',
    },
    vsAi: 'Duelo vs IA',
    vsAiHint:
      'Solo aplica contra la computadora. En línea siempre se tiran los dados.',
    vsAiDifficulty: 'Dificultad de la CPU',
    vsAiDifficultyHint:
      'Cada duelo vs IA elige una receta publicada distinta para esa dificultad. ' +
      'Los niveles más altos usan listas más fuertes. Todas las dificultades siguen la banlist, y tu baraja también. Ganar en Difícil, Experto ' +
      'o Maestro paga más monedas y XP. Cada duelo terminado paga monedas.',
    rankedPrompts: 'Avisos de clasificatoria',
    rankedPromptsHint:
      'Avisos de que alguien espera una clasificatoria. Terminar esa partida paga 1 moneda, hasta 20 veces al día. Después de 20, el aviso sigue y esa partida no paga la moneda extra. Si los apagas, dejan de mostrarse y esa moneda no se paga.',
    rankedPromptsOn: 'Mostrar avisos de clasificatoria',
    vsAiTestHint:
      'La CPU solo juega monstruos normales de poco ATK. Este duelo no da monedas ni XP.',
    vsAiLevels: {
      test: 'Test',
      easy: 'Fácil',
      normal: 'Normal',
      hard: 'Difícil',
      expert: 'Experto',
      master: 'Maestro',
    },
    vsAiDecide: 'Cómo se decide el primer turno',
    vsAiDiceOn: 'Dados',
    vsAiDiceOff: 'Elegir',
    vsAiFirst: 'Quién empieza',
    vsAiYou: 'Tú',
    vsAiCpu: 'CPU',
    mat: 'Tapete',
    matHint:
      'Tu mitad del campo. En línea, el otro duelista ve este tapete. Contra la IA, la CPU recibe un tapete aleatorio cada duelo.',
    followOpponent: 'Seguir al rival en el visor',
    followOpponentHint:
      'Cuando el rival invoca, activa o ataca, esa carta se muestra en el visor.',
    hideCardViewer: 'Ocultar el visor de cartas',
    hideCardViewerHint:
      'Guarda el texto de la derecha para dejar el campo más ancho. Listas como Monster Reborn y Big Eye lo ocultan solas mientras eliges.',
    coinQuality: 'Calidad de la animación de la moneda',
    coinQualityHint:
      'Alta gira la moneda en 3D. Baja gira la misma moneda en plano, y pesa menos si el diálogo 3D trababa el duelo. Se queda en este dispositivo.',
    coinQualityLevel: {
      high: 'Alta',
      low: 'Baja',
    },
    motion: 'Animaciones',
    motionHint:
      'Completas mantiene partículas y vuelos. Reducidas quita partículas, temblores y efectos de campo; las cartas siguen moviéndose. Mínimas deja las cartas en su sitio, sin vuelos 3D, sin foil animado y sin el fondo de campo. Se queda en este dispositivo.',
    motionLevel: {
      full: 'Completas',
      reduced: 'Reducidas',
      minimal: 'Mínimas',
    },
    imageQuality: 'Calidad de imagen',
    imageQualityHint:
      'Nítida detalla las cartas, las fundas y los números de ATK y DEF. Esa es la que viene elegida. Estándar pide menos al teléfono si le cuesta. Actualiza la página para ver el cambio. Se queda en este dispositivo.',
    imageQualityApply: 'Actualiza la página para aplicar este cambio.',
    imageQualityLevel: {
      sharp: 'Nítida',
      standard: 'Estándar',
    },
    foilSweep: 'Brillo del foil',
    foilSweepHint:
      'Completo es el destello de siempre sobre la carta. Ligero le pide menos al teléfono cuando la baraja está llena de foil, y el brillo se ve más simple. Se queda en este dispositivo.',
    foilSweepMode: {
      full: 'Completo',
      light: 'Ligero',
    },
    foilThumbs: 'Animar el foil en las miniaturas',
    foilThumbsHint:
      'El álbum, el baúl y las listas barren cada foil. Apagado, esas cartas quedan con un tinte quieto y solo mientras se ven. La carta abierta sigue brillando. Se queda en este dispositivo.',
    responseMode: 'Cuándo preguntar por trampas',
    responseModeHint:
      'Mínimo es el que viene elegido: solo pregunta cuando una trampa responde a esa jugada. Just Desserts también pregunta una vez al empezar la Battle Phase del rival, si controla un monstruo. Ultimate Offering boca abajo también pregunta ahí, y otra vez cuando declara un ataque. Robbin\' Goblin pregunta al inicio de tu Battle Phase, y cuando el rival ataca un monstruo tuyo boca abajo en Defensa que devolvería daño. Las Counter Trap solo preguntan cuando el rival activa o invoca algo que pueden negar. Auto también pregunta en invocaciones, ataques y al entrar a la Battle Phase. Todo pregunta en cada fase. En No, el juego no pregunta.',
    focusBands: 'Acercar el campo en el teléfono',
    focusBandsHint:
      'En landscape, la cámara se queda en tu mano, sigue la jugada y vuelve. Un botón y un toque cambian la vista.',
    matOpacity: 'Opacidad',
    matRandom: 'Aleatorio',
    matRandomHint: 'Un tapete distinto en cada duelo.',
    matCartoon: 'Cartoon',
    matFlat: 'Planos',
    sleeve: 'Funda',
    sleeveHint:
      'Cartas boca abajo y tu baraja. Contra la IA, la CPU recibe una funda aleatoria cada duelo.',
    sleeveRandom: 'Aleatorio',
    sleeveRandomHint: 'Una funda distinta en cada duelo.',
    leagueRewards: 'Premios de liga',
    leagueLocked: 'Alcanza la liga {league}',
    duel: 'Duelo',
    duelHint:
      'Visor, arte de las cartas y tapete para todos los duelos en este dispositivo.',
    cardArt: 'Arte de las cartas',
    cardArtHint:
      'La ilustración de la carta. TCG es el arte internacional por defecto; ' +
      'OCG es el original japonés. La mayoría coinciden. Algunas, como ' +
      'Monster Reborn, se ven distintas.',
    cardArtTcg: 'TCG',
    cardArtOcg: 'OCG',
    audio: 'Audio',
    audioHint:
      'Música y efectos del duelo. Ambos controles valen en menús, ' +
      'sobres y duelos. Sonido off en el duelo silencia efectos y ' +
      'música hasta que lo vuelvas a encender.',
    music: 'Música',
    sfx: 'Efectos',
    sleeves: {
      'millennium-gaze': 'Mirada milenaria',
      'heart-draw': 'Corazón',
      'kingdom-isle': 'Isla del reino',
      'city-skies': 'Cielos de ciudad',
      'god-triad': 'Tríada',
      'ivory-wyrm': 'Wyrm de marfil',
      'dusk-staff': 'Bastón del ocaso',
      'carnival-ink': 'Tinta de feria',
      'crimson-iris': 'Iris carmesí',
      'five-relics': 'Cinco reliquias',
      'classic-vortex': 'Vórtice clásico',
      'sapphire-vortex': 'Vórtice zafiro',
      'emerald-vortex': 'Vórtice esmeralda',
      'amethyst-vortex': 'Vórtice amatista',
      'rose-vortex': 'Vórtice rosa',
      'silver-vortex': 'Vórtice plateado',
      'last-call': 'Última llamada',
      'league-duelist': 'Duelista',
      'league-challenger': 'Retador',
      'league-champion': 'Campeón',
      'league-king': 'Rey de los Juegos',
    },
    mats: {
      'puzzle-dusk': 'Ocaso del puzzle',
      'white-sky': 'Cielo blanco',
      'moon-circle': 'Círculo lunar',
      'ember-wings': 'Alas de ember',
      'sogen-hills': 'Colinas verdes',
      'umi-tide': 'Marea',
      'sand-temple': 'Templo de arena',
      'toon-fair': 'Feria',
      'shadow-chains': 'Cadenas de sombra',
      'kingdom-arena': 'Arena de duelo',
      'mystic-circle': 'Círculo místico',
      'forbidden-seal': 'Sello prohibido',
      'knight-charge': 'Carga del caballero',
      'elf-grove': 'Bosque élfico',
      'light-swords': 'Espadas de luz',
      'navy-puzzle': 'Puzzle marino',
      'crimson-eye': 'Ojo carmesí',
      'forest-leaf': 'Hoja',
      'gold-star': 'Estrella de oro',
      'violet-moon': 'Luna violeta',
      'charcoal-hex': 'Hexágono',
      'teal-drop': 'Gota',
      'ember-flame': 'Llama',
      'ivory-disk': 'Disco marfil',
      'slate-tribute': 'Tributo pizarra',
      'last-call': 'Última llamada',
      'league-duelist': 'Duelista',
      'league-challenger': 'Retador',
      'league-champion': 'Campeón',
      'league-king': 'Rey de los Juegos',
    },
    devTools: 'DevTools',
    devToolsHint: 'Herramientas de desarrollo. Entra con la contraseña.',
    devToolsPassword: 'Contraseña',
    devToolsUnlock: 'Entrar',
    devToolsWrong: 'Contraseña incorrecta.',
    devToolsGrant: 'Otorgar todas las cartas',
    devToolsGrantHint:
      'Pone cada carta del catálogo en tu colección, con 3 copias de cada rareza.',
    devToolsGranted: 'Listo. Revisa la Colección o arma una baraja.',
    devToolsPacksHint:
      'Añade Master Packs sin gastar monedas. Ábrelos en Sobres.',
    devToolsPacksX5: 'Reclamar x5',
    devToolsPacksX10: 'Reclamar x10',
    devToolsPacksGranted: 'Se añadieron {n} sobres. Ábrelos en Sobres.',
    devToolsFailed:
      'No se pudo aplicar. Entra a tu cuenta e inténtalo de nuevo.',
    devToolsLock: 'Cerrar',
    devToolsReset: 'Resetear esta cuenta',
    devToolsResetHint:
      'Borra colección, barajas, monedas, XP y la liga. Empiezas de nuevo con los tres starters.',
    devToolsResetDone: 'Cuenta reseteada. Abre los starters en Sobres.',
    devToolsCoins: 'Agregar 100 monedas',
    devToolsCoinsDone: 'Se añadieron 100 monedas.',
    devToolsRank: 'Asignar liga',
    devToolsRankHint: 'Salta la colocación y escribe esta liga en la cuenta.',
    devToolsRankDone: 'Liga actualizada.',
    devToolsPlacement: 'Colocación',
  },
  feedback: {
    title: 'Buzón',
    lead:
      'Sugerencias, quejas o un error. Estás dentro de tu cuenta, así sabemos quién lo envió.',
    kind: 'De qué se trata',
    kinds: {
      suggestion: 'Sugerencia',
      complaint: 'Queja',
      bug: 'Error',
    },
    reportBug: 'Reportar un error',
    message: 'Mensaje',
    placeholder: 'Qué pasó, o qué cambiarías…',
    send: 'Enviar',
    thanks: 'Gracias. Leemos cada nota.',
    thanksBug:
      'Gracias. Si el error es real, te damos 1 moneda y 1 Master Pack después de revisarlo.',
    thanksCoin: 'Gracias. Te dimos 1 moneda.',
    thanksCoinDone: 'Gracias. La moneda de hoy ya está en tu cuenta.',
    rate: 'Ya enviaste varias notas hoy. Inténtalo de nuevo mañana.',
    error: 'No se pudo enviar. Escribe un poco más e inténtalo de nuevo.',
  },
  lobby: {
    title: 'Sala en línea',
    quickMatch: 'Partida rápida',
    queueWaiting: '{n} en cola',
    queueClosed: 'La clasificatoria está en pausa. Vuelve a intentarlo en unos minutos.',
    rankedOffer: 'Juega una y te damos {n} monedas.',
    rankedHint: 'Clasificatoria. Tu liga está en el perfil.',
    casual: 'Cola casual',
    casualHint: 'Tu liga no se mueve.',
    eventHint: 'Evento semanal. 7 monedas al ganar, 5 al perder o empatar, igual que clasificatoria. Tu liga no se mueve. Al cerrar, Master Packs por porcentaje: 20 el top 1%, 15 el resto del top 10%, 8 el resto del top 25%, 4 el resto del top 50% y 2 el resto.',
    privateRooms: 'Salas privadas',
    privateHint: 'No es clasificatoria. Las salas abiertas esperan a un segundo duelista.',
    watch: 'Ver duelos',
    watchHint: 'PvP en curso. Ves el campo, no las manos.',
    back: '← Atrás',
    using: 'Usando: {name}',
    playDeck: 'Jugar con',
    deckNotReady: ' (no lista)',
    edit: 'Editar',
    buildDeck: 'Armar baraja',
  },
  rooms: {
    title: 'Salas privadas',
    lead: 'No es clasificatoria. Crea una sala o únete a una que esté esperando.',
    create: 'Crear una sala',
    join: 'Unirse',
    joinCode: 'Unirse con un código',
    codePlaceholder: 'CÓDIGO',
    empty: 'No hay salas esperando. Crea una, o pide el código a un amigo.',
    seats: '{taken}/{max}',
    back: '← Atrás',
    connecting: 'Cargando salas…',
    error: 'No se pudo conectar al servidor. Revisa tu conexión.',
    badCode: 'Escribe el código de 4 caracteres.',
    yours: 'Tuya',
  },
  watch: {
    title: 'Ver duelos',
    lead: 'Partidas clasificatorias y salas privadas en curso. Las manos y las cartas boca abajo quedan ocultas.',
    filter: 'Mostrar',
    all: 'Todos',
    ranked: 'Clasificatorias',
    event: 'Evento',
    casual: 'Salas privadas',
    empty: 'No hay duelos en curso.',
    connecting: 'Cargando duelos…',
    error: 'No se pudo conectar con el servidor. Revisa tu conexión.',
    watch: 'Ver',
    yours: 'Tu duelo',
    back: '← Inicio',
    hand: 'Mano',
    deck: 'Baraja',
    modeRanked: 'Clasificatoria',
    modeEvent: 'Evento',
    modeCasual: 'Sala privada',
    offline: 'desconectado',
  },
  packs: {
    title: 'Sobres',
    yours: 'Tus sobres',
    empty: 'No tienes sobres sin abrir. Compra uno en la tienda o empieza como jugador nuevo.',
    shop: 'Tienda',
    shopNote: 'Gana duelos o completa misiones diarias para obtener monedas. Un sobre de tienda cuesta:',
    open: 'Abrir',
    opening: 'Abriendo…',
    openFailed: 'El sobre no se abrió. Inténtalo de nuevo.',
    openThree: 'Abrir 3',
    openFive: 'Abrir 5',
    openTen: 'Abrir 10',
    openAnother: 'Abrir otro',
    packOf: 'Sobre {n} / {total}',
    nextPack: 'Siguiente sobre',
    tapNextPack: 'Toca para el siguiente sobre',
    claim: 'Reclamar sobre',
    buy: 'Comprar sobre',
    buyThree: 'Comprar 3',
    buyFive: 'Comprar 5',
    buyTen: 'Comprar 10',
    buying: 'Comprando…',
    buyFailed: 'No se compró el sobre. Inténtalo de nuevo.',
    buyNeedCoins: 'No te alcanzan las monedas.',
    buyRate: 'Demasiadas compras. Espera un momento e inténtalo de nuevo.',
    buySignedOut: 'Entra de nuevo para comprar un sobre.',
    boughtOne: '+1 sobre',
    boughtMany: '+{n} sobres',
    price: '{n} monedas',
    have: 'Tienes x{count}',
    complete: '{percent}%',
    completeOf: '{owned} / {total}',
    completeAria: '{percent} por ciento. {owned} de {total} cartas',
    contents: 'Cartas',
    contentsProgress: '{owned} / {total} · {percent}%',
    haveCard: 'Ya tienes esta carta',
    contentsSearch: 'Buscar una carta',
    contentsCount: '{n} cartas',
    contentsEmpty: 'Ninguna carta coincide.',
    contentsChase:
      'Una Ultra o Secret también puede salir Ghost, Helios, Nightglass o Stormwake.',
    contentsMaster: 'Cualquier carta del juego. Cada copia tira su propio foil.',
    collection: 'Colección',
    vaultLabel: 'Kaiba Corp',
    binderLabel: 'Colección',
    tagline: {
      'starter-beasts': 'Inicio · 20 monstruos · Blue-Eyes',
      'starter-runes': 'Inicio · 20 mágicas y trampas · Swords',
      'starter-crucible': 'Inicio · 5 Extra Deck · Gaia',
      'shop-onyx': 'Especial · 5 cartas de todo el set',
      'set-lob': '9 cartas · Legend of Blue-Eyes y los starters',
      'promo-lob': 'Promo · 1 Blue-Eyes White Dragon',
      'set-mrd': '9 cartas · Metal Raiders',
      'promo-mrd': 'Especial · 5 cartas de Metal Raiders · Ultra Rare o más',
      'set-mrl': '9 cartas · Magic Ruler',
    },
    names: {
      'starter-beasts': 'Legend of Blue Eyes White Dragon',
      'starter-runes': 'Swords of Light',
      'starter-crucible': 'Gaia the Dragon Champion',
      'set-lob': 'Legend of Blue Eyes White Dragon',
      'promo-lob': 'Sobre promo',
      'set-mrd': 'Sobre de Metal Raiders',
      'promo-mrd': 'Sobre especial de Metal Raiders',
      'set-mrl': 'Sobre de Magic Ruler',
    },
    rarity: {
      common: 'Common',
      rare: 'Rare',
      super: 'Super Rare',
      ultra: 'Ultra Rare',
      ghost: 'Ghost Rare',
      secret: 'Secret Rare',
      helios: 'Helios Rare',
      nightglass: 'Nightglass Rare',
      stormwake: 'Stormwake Rare',
    },
    sfxOn: 'Sonido on',
    sfxOff: 'Sonido off',
    skip: 'Saltar',
    tearHint: 'Toca el sobre y desliza para abrirlo',
    openBtn: 'Abrir',
    new: 'Nueva',
    tapReveal: 'Toca para revelar',
    tapLast: 'La última… toca para revelar',
    tapNext: 'Toca para la siguiente',
    tapSummary: 'Toca para ver el resumen',
    done: 'Listo',
    toDeck: 'Ir a la baraja',
  },
  collection: {
    kicker: 'Álbum',
    title: 'Colección',
    lead: 'Una casilla por carta. Primero LOB, luego las barajas iniciales de Yugi y Kaiba.',
    openPacks: 'Abrir sobres',
    search: 'Buscar nombre o LOB / SDY / SDK…',
    filter: 'Mostrar',
    all: 'Todas',
    owned: 'Tienes',
    missing: 'Faltan',
    setFilter: 'Set',
    setAll: 'Todos los sets',
    progress: '{owned} de {total} cartas',
    emptyFilter: 'Ninguna carta coincide con estos filtros.',
    loading: 'Cargando colección…',
    preferredFoil: 'Rareza preferida',
    slotEmpty: 'Esta casilla está vacía. Aún no tienes esta carta.',
    searchFilters: 'Buscar y filtros',
    applyFilters: 'Aplicar',
    resetFilters: 'Quitar filtros',
    clearSearch: 'Borrar búsqueda',
  },
  welcome: {
    kicker: 'Bienvenido',
    title: 'Tus primeros sobres',
    lead:
      'Empiezas con tres sobres de inicio y tres sobres Master Pack ' +
      '(cinco cartas cada uno). Ábrelos, arma una baraja de 40 cartas y ' +
      'después puedes jugar un duelo. Si borras el almacenamiento del ' +
      'navegador, vuelves a ser un jugador nuevo.',
    cta: 'Ver mis sobres',
  },
  needDeck: {
    title: 'Arma una baraja de 40',
    body: 'El duelo usa solo las cartas que sacaste de los sobres. Abre tus sobres y guarda una baraja principal de al menos 40 cartas.',
    toPacks: 'Ir a sobres',
    deckBuilder: 'Baraja',
  },
  deck: {
    title: 'Baraja',
    backHome: '← Volver al inicio',
    collection: 'Colección',
    tabCollection: 'Colección',
    tabTrunk: 'Baúl',
    tabDeck: 'Baraja',
    showTrunk: 'Ver baúl',
    showDeck: 'Ver baraja',
    ownedOnly: 'Solo cartas sacadas de sobres.',
    openPacks: 'Abrir sobres',
    search: 'Buscar cartas...',
    clearSearch: 'Borrar búsqueda',
    searchFilters: 'Buscar y filtros',
    applyFilters: 'Aplicar',
    allTypes: 'Todos los tipos',
    allMonsters: 'Todos los monstruos',
    spell: 'Mágica',
    trap: 'Trampa',
    allAttributes: 'Todos los atributos',
    allLevels: 'Todos los niveles',
    allRaces: 'Todas las razas',
    allSubtypes: 'Todos los subtipos',
    allRarities: 'Todas las rarezas',
    allSets: 'Todas las expansiones',
    availabilityAll: 'Todas',
    availabilityFree: 'Quedan copias',
    availabilityNotInDeck: 'Fuera de la baraja',
    sortBy: 'Ordenar por',
    sortNameAsc: 'Nombre A–Z',
    sortNameDesc: 'Nombre Z–A',
    sortAcquiredDesc: 'Adquisición (reciente)',
    sortAcquiredAsc: 'Adquisición (antigua)',
    sortLevelDesc: 'Nivel (alto)',
    sortLevelAsc: 'Nivel (bajo)',
    sortAtkDesc: 'ATK (alto)',
    sortAtkAsc: 'ATK (bajo)',
    sortDefDesc: 'DEF (alto)',
    sortDefAsc: 'DEF (bajo)',
    sortType: 'Tipo',
    sortRarity: 'Rareza',
    sortSet: 'Expansión (LOB primero)',
    resetFilters: 'Quitar filtros',
    moreFilters: 'Más filtros',
    fewerFilters: 'Ocultar filtros',
    emptyCollection: 'Aún no tienes cartas.',
    openForCards: 'Abre sobres para conseguir cartas',
    currentDeck: 'Baraja actual',
    min40: 'Mín: 40',
    autoBuild: 'Armar automático',
    autoNeed: 'Necesitas 40 cartas de la baraja principal. Tienes {n}.',
    autoHint: 'Respeta la banlist. 20 monstruos + 20 mágicas/trampas, primero las que más ganan esta temporada.',
    sort: 'Ordenar',
    bestFoils: 'Mejores rarezas',
    bestFoilsHint: 'Pone en la baraja tus copias más raras de cada carta.',
    undo: 'Deshacer',
    undoHint: 'Deshace el último cambio de esta baraja. Ctrl+Z.',
    undoNamed: 'Deshacer {name}',
    undoRestoreHint: 'Devuelve {name} a la baraja. Ctrl+Z.',
    undoRestored: '{name} volvió a la baraja',
    undoDone: 'Se deshizo el último cambio',
    clear: 'Vaciar baraja',
    monsters: 'Monstruos',
    spells: 'Mágicas',
    traps: 'Trampas',
    emptyMain: 'Tu baraja está vacía',
    emptyMainHint: 'Toca para agregar una copia. Mantén pulsado para enviar hasta 3.',
    pvpLimitBadge: 'Máximo {n}',
    banlistKicker: 'Metal Raiders',
    banlistTitle: 'Banlist',
    banlistLead:
      'Estas cartas superan el máximo de copias. Bájalas al tope indicado e inténtalo de nuevo.',
    banlistRow: 'tienes {have} / máximo {max}',
    banlistClose: 'Cerrar',
    banlistEdit: 'Editar baraja',
    extraDeck: 'Extra Deck',
    emptyExtra: 'Sin monstruos de fusión en el Extra Deck',
    addCopy: 'Agregar a la baraja',
    removeCopy: 'Quitar de la baraja',
    sheetAdd: 'Agregar',
    sheetRemove: 'Quitar',
    copyFoil: 'Rareza de esta copia',
    deckName: 'Nombre de la baraja...',
    save: 'Guardar baraja',
    saved: '¡Guardado!',
    addMore: 'Agrega {n} cartas más',
    defaultName: 'Mi baraja Yu-Gi-Oh',
    myDeck: 'Mi baraja',
    buildForty: 'Arma una baraja de 40',
    savedOk: 'Se guardó “{name}”.',
    savedOkActive:
      'Guardado. Los duelos vs IA y en línea van a usar “{name}”. La IA usa una baraja Standard.',
    savedOther:
      'Se guardó “{name}”. Los duelos siguen usando “{active}”. Elige Usar en duelos para cambiar.',
    savedUnowned:
      'Guardado, pero hay copias que no tienes en la colección. Quítalas o abre más sobres para poder jugar un duelo.',
    savedIllegal:
      'Guardado, pero la baraja no es legal (40–60 en la principal, máximo 3 copias, fusiones solo en Extra). Arréglalo para jugar un duelo.',
    savedDraft:
      'Guardado. Puedes seguir editando. Los duelos necesitan 40–60 cartas en la principal que tengas.',
    hintUnsaved: 'Cambios sin guardar. Los duelos siguen usando “{name}” hasta que guardes.',
    hintEmpty:
      'Puedes guardar cuando quieras. Los duelos necesitan 40 cartas en la principal que tengas.',
    hintUnowned:
      'Esta baraja guardada usa cartas que no tienes, así que el duelo no va a empezar.',
    hintIllegal: 'Esta baraja guardada no es legal, así que el duelo no va a empezar.',
    hintEditingOther:
      'Estás editando “{edit}”. Los duelos siguen usando “{active}” hasta que cambies.',
    newDeckCard: 'Nueva baraja',
    openDeck: 'Editar esta baraja',
    backToDecks: '← Tus barajas',
    savedDecks: 'Tus barajas',
    newDeck: 'Nueva',
    duplicate: 'Duplicar',
    deleteDeck: 'Borrar',
    useInDuels: 'Usar en duelos',
    inDuels: 'En duelos',
    tournamentLock: 'En el torneo',
    tournamentLocked:
      'Esta baraja está en el torneo. No se puede editar ni borrar hasta que termine o salgas de la inscripción.',
    deckLimit: 'Puedes guardar hasta 10 barajas.',
    confirmDelete: '¿Borrar “{name}”?',
    confirmDiscard: '¿Descartar los cambios sin guardar?',
    copySuffix: 'Copia de {name}',
    useNeedLegal:
      'Esta lista tiene que ser legal y de cartas que tengas (40–60 en la principal) para usarla en un duelo.',
    addedCopies: 'Se agregaron {n} a la baraja',
    holdToAddThree: 'Clic para agregar 1. Mantén pulsado para enviar hasta 3.',
    deckList: 'Ver lista',
    deckListHint: 'La baraja completa en una pantalla, lista para capturar.',
    deckListShare: 'Compartir',
    deckListCopied: 'Copiada',
    deckListView: 'Vista de la lista',
    deckListNames: 'Nombres',
    deckListSprites: 'Cartas',
    deckListImage: 'Imagen',
    deckListImageBusy: 'Guardando…',
    deckListImageFail: 'No se pudo guardar',
    deckListMain: 'Principal {n}',
    deckListExtra: 'Extra {n}',
    recycle: 'Reciclar copias',
  },
  recycle: {
    kicker: 'Barajas',
    title: 'Reciclar copias',
    back: '← Tus barajas',
    empty: 'No tienes copias de más. Una carta entra aquí cuando tienes más de 3.',
    rowCoins: '{n} monedas',
    summary: '{n} copias · {coins} monedas',
    selectAll: 'Seleccionar todo',
    clear: 'Quitar selección',
    selectScope: 'Aplica a',
    lowerRarity: 'Rareza más baja',
    higherRarity: 'Rareza más alta',
    selectHint: 'Marca cada copia de más, empezando por esta rareza. De cada carta se quedan 3.',
    confirm: 'Reciclar',
    busy: 'Reciclando…',
    done: 'Recibiste {n} monedas.',
    failed: 'No se pudo reciclar. Inténtalo de nuevo.',
    tournamentBlocked:
      'No puedes reciclar mientras estés inscrito en el torneo. Vuelve cuando termine, o si sales de la inscripción.',
  },
  duel: {
    you: 'TÚ',
    opponent: 'RIVAL',
    trap: 'Trampa',
    field: 'CAMPO',
    chainBanner: 'Cadena',
    turn: 'Turno {n}',
    yourTurn: 'Tu turno',
    opponentTurn: 'Turno del rival',
    youParen: '(Tú)',
    opponentParen: '(Rival)',
    phaseBanner: {
      draw: 'Fase de Robo',
      standby: 'Fase de Standby',
      main1: 'Fase Principal 1',
      battle: 'Fase de Batalla',
      main2: 'Fase Principal 2',
      end: 'Fase Final',
    },
    dice: {
      kicker: 'Primer turno',
      title: 'Dados para empezar',
      hint: 'El dado más alto empieza el duelo.',
      roll: 'Tirar',
      rolling: 'Tirando…',
      tie: 'Empate. Otra vez…',
      youFirst: 'Empiezas tú.',
      oppFirst: 'Empieza el rival.',
      youFirstBig: '¡Empiezas tú!',
      namedFirst: '¡Empieza {name}!',
      cpu: 'CPU',
    },
    vs: {
      kicker: 'Inicio del duelo',
      skip: 'Saltar',
    },
    roster: {
      kicker: 'Duelistas',
      you: 'Tú',
      rival: 'Rival',
      placement: 'Colocación',
      placementLeft: 'Quedan {n} duelos',
      noRank: 'Sin rango',
      level: 'Nivel {n}',
      placeRanked: 'Clasificatoria #{n}',
      placeLevel: 'Top de nivel #{n}',
      placeAi: '{name} #{n}',
      record: '{wins}–{losses}',
      recordDraws: '{wins}–{losses}–{draws}',
      noDuels: 'Sin duelos',
      winStreak: '{n} victorias seguidas',
      lossStreak: '{n} derrotas seguidas',
    },
    soundOn: 'Sonido on',
    soundOff: 'Sonido off',
    animSpeed1: 'Anim: lenta',
    animSpeed2: 'Anim: normal',
    animSpeed3: 'Anim: rápida',
    chat: {
      title: 'Chat',
      placeholder: 'Mensaje...',
      send: 'Enviar',
      show: 'Chat',
      hide: 'Ocultar chat',
    },
    roomCode: 'Código de sala:',
    back: 'Atrás',
    backHome: 'Volver al inicio',
    surrender: 'Rendirse',
    surrenderConfirm: '¿Te rindes? No ganas monedas ni XP.',
    leaveConfirm: '¿Sales de este duelo? Termina ahora y gana tu rival.',
    tournamentLeaveConfirm: 'Si sales de la sala, pierdes este partido.',
    tournamentLeave: 'Salir y perder',
    tournamentStay: 'Quedarme',
    surrenderCancel: 'Seguir jugando',
    rankedCall: '{name} espera una clasificatoria.',
    rankedCallWait: 'Espera una clasificatoria.',
    rankedCallGo: 'Duelo',
    rankedCallGoPay: 'Duelo contra {name} por {n} monedas',
    rankedCallGoHint: 'Deja este duelo y juega una clasificatoria contra {name}. Termínala para cobrar las monedas.',
    rankedCallIgnore: 'Ignorar',
    viewerCard: 'Carta',
    viewerSettings: 'Ajustes',
    viewerLog: 'Registro',
    viewerEmpty: 'Toca una carta para verla aquí.',
    viewerFaceDown: 'Carta boca abajo.',
    hideViewer: 'Ocultar info de carta',
    showViewer: 'Mostrar info de carta',
    gear: 'Ajustes del duelo',
    focusCycle: 'Cambiar la vista del campo',
    shuffleHand: 'Barajar mano',
    nextPhase: 'Siguiente',
    holdToEndTurn: 'Mantén pulsado para terminar el turno (sin Batalla ni Main 2)',
    response: {
      title: 'Trampas',
      auto: 'Auto',
      always: 'Todo',
      minimal: 'Mínimo',
      off: 'No',
      hint: 'Cuándo el juego te pregunta si activas una trampa. Toca para ciclar Todo, Auto, Mínimo y No.',
    },
    connecting: 'Conectando...',
    reconnecting: 'Se cortó la conexión. Reconectando…',
    opponentReconnecting: 'Tu rival perdió la conexión. Tiene un minuto para volver.',
    watching: 'Viendo el duelo',
    spectators: 'Espectadores',
    spectatorsCount: '{n} viendo',
    replay: {
      kicker: 'Repetición',
      play: 'Reproducir',
      pause: 'Pausa',
      step: 'Paso',
      speed: '{n}×',
      speedLabel: 'Velocidad {n}×',
      collapse: 'Recoger controles',
      expand: 'Extender controles',
      move: 'Arrastra para moverlos',
      loading: 'Cargando la repetición…',
      missing: 'Esta repetición ya no está disponible.',
      stale: 'Esta repetición no se puede ver con las reglas actuales.',
    },
    watchWaiting: 'Esperando a {name}',
    watchWinner: 'Ganó {name}',
    watchDraw: 'El duelo terminó',
    watchBack: 'Volver al panel',
    watchBackList: 'Volver a la lista',
    watchOver: {
      lifePoints: 'Los Life Points de un jugador llegaron a 0.',
      deckOut: 'Un jugador no pudo robar una carta.',
      exodia: 'Un jugador reunió las cinco piezas de Exodia.',
      surrender: 'Un jugador se rindió.',
      forfeit: 'Un jugador abandonó la sala.',
      timeout: 'Se le acabó el tiempo a un jugador.',
      roundTime: 'Se acabó el tiempo de la ronda.',
    },
    creating: 'Creando sala...',
    joining: 'Entrando a la sala...',
    searching: 'Buscando rival...',
    tournamentWait: 'Esperando tu duelo del torneo...',
    tournamentWaitFor: 'Esperando a {name}',
    tournamentAdvance: 'Pasas de ronda.',
    tournamentTimeUp: 'Se acabó el tiempo.',
    searchingCasual: 'Buscando un duelo casual. Tu liga no se mueve.',
    searchingEvent: 'Buscando un duelo de evento. Tu liga no se mueve.',
    searchingElapsed: 'Tiempo en cola: {time}',
    searchingStill: 'Seguimos buscando. La cola sigue activa.',
    queueWindowNear: 'Cerca de tu rating (±{n})',
    queueWindowMid: 'Más lejos (±{n})',
    queueWindowOpen: 'Cualquier duelista en la cola',
    queueWidenIn: 'Se amplía en {n} s',
    queueOpenIn: 'Cualquiera entra en {n} s',
    queueStar: 'Toca la estrella',
    queueStarBonus: 'Estrella chica',
    queueStarCount: '{n} estrellas',
    queueStarBest: 'Mejor: {n}',
    queueStarCoin: '¡Una moneda!',
    queueRun: 'Toca para saltar',
    queueRunOver: 'Toca para seguir',
    queueRunCount: '{n} pasos',
    waitingJoin: 'Esperando a que se una el rival...',
    victory: 'VICTORIA',
    defeat: 'DERROTA',
    victorySub: '¡Ganaste el duelo!',
    defeatSub: 'El rival te derrotó.',
    overBy: {
      lifePointsWin: 'Los Life Points del rival llegaron a 0.',
      lifePointsLose: 'Tus Life Points llegaron a 0.',
      deckOutWin: 'El rival no pudo robar una carta.',
      deckOutLose: 'No pudiste robar una carta.',
      exodiaWin: 'Reuniste las cinco piezas de Exodia en tu mano.',
      exodiaLose: 'El rival reunió las cinco piezas de Exodia.',
      surrenderWin: 'El rival se rindió.',
      surrenderLose: 'Te rendiste.',
      forfeitWin: 'El rival abandonó la sala.',
      forfeitLose: 'Abandonaste la sala.',
      timeoutWin: 'Al rival se le acabó el tiempo.',
      timeoutLose: 'Se te acabó el tiempo.',
      roundTimeWin: 'Se acabó el tiempo de la ronda.',
      roundTimeLose: 'Se acabó el tiempo de la ronda.',
      aiTooLong: 'Este duelo llegó a una hora y se cerró. Sin monedas ni XP.',
      aiEnded: 'Este duelo se cerró. Sin monedas ni XP.',
    },
    clockHint: 'Tiempo que te queda. En cero, pierdes. Al cambiar el turno se suma.',
    exodia: {
      kicker: 'El prohibido',
      sub: 'Las cinco piezas, en la mano',
      skip: 'Toca para saltar',
    },
    reward: '+{n} monedas',
    rankedNudgePaid: 'Incluye {n} monedas por jugar la clasificatoria.',
    rankedOffer: 'Juega una clasificatoria y te damos {n} monedas.',
    rankedOfferGo: 'Jugar clasificatoria',
    playAgain: 'Jugar de nuevo',
    tournamentPrizes: 'Recibirás los premios al final del torneo en tu buzón.',
    returnLobby: 'Volver al inicio',
    youWin: '¡GANASTE!',
    youLose: 'PERDISTE',
    gameOver: 'FIN DEL DUELO',
    backToMenu: 'Volver al menú',
    extraYours: 'Tu Extra Deck',
    extraOpp: 'Extra Deck del rival',
    banishedYours: 'Tus cartas desterradas',
    banishedOpp: 'Cartas desterradas del rival',
    gyYours: 'Tu Cementerio',
    gyOpp: 'Cementerio del rival',
    log: {
      empty: 'Aquí verás las jugadas del duelo.',
      aCard: 'una carta',
      turn: 'Turno {n} — {name}',
      phase: '{name} — {phase}',
      draw: '{name} robó {card}',
      drawHidden: '{name} robó una carta',
      summon: '{name} invocó a {card}',
      tributeSummon: '{name} invocó por Sacrificio a {card}',
      set: '{name} colocó una carta',
      flip: '{card} se volteó boca arriba',
      posAtk: '{card} pasó a Posición de Ataque',
      posDef: '{card} pasó a Posición de Defensa',
      spell: '{name} activó {card}',
      trap: '{name} activó {card}',
      effect: '{card}: efecto activado',
      attack: '{card} ataca a {target}',
      attackDirect: '{card} ataca directamente',
      replay: '{card}: Replay — elige un ataque nuevo o pasa',
      destroy: '{card} fue destruida',
      banish: '{card} fue desterrada',
      toHand: '{card} volvió a la mano',
      lp: '{name}: {lp} LP ({delta})',
      gameOver: 'Gana {name}',
      message: '{text}',
    },
    gyCount: '{n} cartas',
    menu: {
      tributeAtk: 'Invocar por Sacrificio (ATK)',
      tributeSet: 'Colocar por Sacrificio',
      asTribute: 'Elegir como sacrificio',
      undoTribute: 'Quitar el sacrificio',
      normalAtk: 'Invocación Normal (ATK)',
      setMonster: 'Colocar (DEF boca abajo)',
      activate: 'Activar',
      set: 'Colocar',
      flipSummon: 'Invocación de Volteo',
      changePosition: 'Cambiar Posición',
      attackDirect: 'Atacar directamente',
      attackThis: 'Atacar a {name}',
      attackFaceDown: 'Atacar al monstruo boca abajo',
      attackPick: 'Atacar un monstruo',
      equip: 'Equipar',
      specialAtk: 'Invocación Especial (ATK)',
      specialDef: 'Invocación Especial (DEF)',
    },
    picker: {
      special: '¿Qué monstruo Invocar de Modo Especial?',
      fusion: '¿Qué monstruo Invocar por Fusión?',
      banishGy: 'Destierra 1 o 2 monstruos del Cementerio rival',
      lastWill: '¿Invocar desde la baraja? Si cancelas, puedes hacerlo después en este turno.',
      fromCard: 'Efecto de {card}',
      flute: 'Invoca de Modo Especial hasta 2 Dragones de tu mano',
      egotist: 'Invoca de Modo Especial a Dama Arpía o a Hermanas de la Dama Arpía',
      fromHand: 'Mano',
      fromDeck: 'Baraja',
      spy: 'Mira 1 carta de la mano del rival',
      peek: 'Miraste estas cartas',
      bigEye: 'Vuelve a ponerlas. La primera que elijas queda arriba de tu Deck.',
      peekReveal: 'El Místico Severo reveló estas cartas',
      peekSearch: 'Añadida a la mano',
      sangan: 'Añade 1 monstruo con 1500 ATK o menos desde tu baraja',
      witch: 'Añade 1 monstruo con 1500 DEF o menos desde tu baraja',
      thunderDragon: 'Añade Dragón de Trueno desde tu baraja',
      searchDeck: 'Añade una carta desde tu baraja',
      yours: 'Tuya',
      opp: 'Rival',
      ownerHand: 'Si vuelve a la mano, regresa a la de su dueño.',
      gyEmpty: 'Vacío',
      confirm: 'Confirmar',
      close: 'Cerrar',
      cancel: '✕ cancelar',
      selectExact: 'Elige {n}',
      chainOrder: 'Orden de la cadena. La primera que elijas se resuelve al final.',
      chainSearch: 'Busca en la baraja',
      chainSword: 'Vuelve a la baraja',
      chainLife: 'Pierdes Life Points',
      chainDiscard: 'El rival descarta',
      chainDraw: 'Robas 1',
      chainDrawOpp: 'El rival roba 2',
      selectRange: 'Elige {min}–{max}',
      doomedDiscard: 'Descarta 1 carta',
      blastJuggler: 'Destruye 2 monstruos boca arriba con 1000 ATK o menos',
      coffin: 'Descarta de 1 a 3 monstruos de tu mano',
      gySpell: 'Añade 1 Mágica de tu Cementerio a tu mano',
      gyTrap: 'Añade 1 Trampa de tu Cementerio a tu mano',
      magicJammer: 'Descarta 1 carta para negar esa Mágica',
      soulRelease: 'Destierra hasta 5 cartas de cualquier Cementerio',
      yadoBottom: 'Pon cartas al fondo de tu baraja. La última que elijas queda hasta abajo.',
    },
    coin: {
      heads: 'Cara',
      tails: 'Cruz',
      close: 'Cerrar',
    },
    prompt: {
      cancel: '✕ cancelar',
      pass: 'No, pasar',
      activate: 'Activar {name}',
      offeringIgnite: 'Ofrenda Final: ¿pagar 500 LP para Invocar de Modo Normal o Colocar?',
      offeringPayBtn: 'Pagar 500 LP: {name}',
      offeringPayAction: 'Pagar 500 LP',
      trapOnSummon: '¿Activar una Trampa en respuesta a la invocación?',
      trapOnAttack: '¿Activar una Trampa en respuesta al ataque?',
      trapOnDamage: '¿Activar una Trampa antes del cálculo de daño?',
      chainTo: '¿Encadenar a {name}?',
      trapActivate: '¿Activar una Trampa?',
      discard: 'Límite de mano — descarta {n} carta(s): toca las cartas de tu mano',
      waitingDiscard: 'Esperando a que el rival descarte…',
      flipTarget: '{name}: elige un objetivo — toca una carta resaltada',
      selectHighlighted: 'Elige la carta resaltada',
      selectNamed: 'Elige {name}',
      chainOrder: 'Ordena la cadena. La primera se resuelve al final: {names}',
      chainOrderGo: 'Usar este orden',
      waitingChainOrder: 'Esperando a que el rival ordene la cadena…',
      waitingTarget: 'Esperando a que el rival elija un objetivo…',
      coinCall: '{name}: elige cara o cruz',
      heads: 'Cara',
      tails: 'Cruz',
      waitingCoin: 'Esperando a que el rival elija cara o cruz…',
      blastJuggler:
        '{name}: ¿Tributarlo para destruir 2 monstruos boca arriba con 1000 de ATK o menos?',
      mushroomGive: '{name}: ¿Pagar 500 LP para darle su control al rival?',
      choiceYes: 'Sí',
      choiceNo: 'No',
      waitingChoice: 'El rival está decidiendo…',
      waitingRespond: 'El rival está decidiendo…',
      viewingOwnGy: 'El rival está viendo su Cementerio…',
      viewingYourGy: 'El rival está viendo tu Cementerio…',
      viewingOwnGyNamed: '{name} está viendo su Cementerio…',
      viewingOppGyNamed: '{name} está viendo el Cementerio de {other}…',
      waitingOffering:
        'Esperando a que el rival invoque de Modo Normal o coloque…',
      offeringPay:
        'Ofrenda Final: paga 500 LP y luego Invoca de Modo Normal o Coloca',
      offeringSummon:
        'Ofrenda Final: Invoca de Modo Normal o Coloca desde tu mano',
    },
    position: {
      summon: '¿Invocar {name} en ATK o Colocar?',
      select: 'Elige la posición de {name}',
      attack: 'ATAQUE',
      defense: 'DEFENSA',
      set: 'COLOCAR',
      faceDownDef: 'DEF boca abajo',
    },
    error: {
      roomGone: 'No se pudo retomar el duelo.',
      queueClosed: 'La clasificatoria está en pausa. Vuelve a intentarlo en unos minutos.',
      eventClosed: 'Esta cola de evento está cerrada.',
      eventDeck: 'Tu baraja no cumple las reglas de este evento.',
      queueSwitched: 'Entraste a la otra cola.',
      tournamentBusy: 'Termina primero tu duelo del torneo.',
      deck_banlist: 'Tu baraja no cumple la banlist.',
      not_friends: 'Ese duelista no está en tu lista de amigos.',
      friend_offline: 'Ese amigo está desconectado.',
      friend_in_duel: 'Ese amigo ya está en un duelo.',
      invalid_username: 'Ese nombre no es válido.',
      waitingTrapResponse: 'Esperando una respuesta de Trampa',
      discardFirst: 'Primero debes descartar hasta el límite de la mano',
      waitingFlipTarget: 'Esperando a que se elija el objetivo de un Flip Effect',
      waitingTarget: 'Esperando a que se elija un objetivo',
      waitingOffering: 'Esperando Ofrenda Final',
      offeringSummonOrPass: 'Invoca de Modo Normal, Coloca o pasa',
      offeringSummonOwed: 'Ofrenda Final: Invoca de Modo Normal o Coloca el monstruo que ya pagaste',
      notYourTurn: 'No es tu turno',
      notMainPhase: 'No estás en una Main Phase',
      notBattlePhase: 'No estás en la Battle Phase',
      notBattleStep: 'No estás en el Battle Step',
      attackResolving: 'Un ataque todavía se está resolviendo',
      notNow: 'No puedes hacer eso ahora',
      notNowWaiting: 'No puedes hacer eso ahora: estás esperando al rival',
      skipEndOnly: 'Solo puedes saltar a la End Phase',
      cannotSkipEnd: 'No puedes saltar a la End Phase desde aquí',
      cardNotInHand: 'La carta no está en la mano',
      notMonster: 'No es un monstruo',
      fusionNoNormal: 'Los monstruos de Fusión no se pueden Invocar de Modo Normal',
      requiresTribute: 'Requiere una Invocación por Sacrificio',
      monsterZoneOccupied: 'La zona de monstruo está ocupada',
      invalidZone: 'Zona inválida',
      fusionNoTribute: 'Los monstruos de Fusión no se pueden Invocar por Sacrificio',
      noTributesNeeded: 'No requiere sacrificios',
      needsExactTributes: 'Necesita exactamente {n} sacrificio(s)',
      invalidTribute: 'Sacrificio inválido',
      noFreeMonsterZone: 'No hay zona de monstruo libre',
      noNormalSummon: 'Este monstruo no puede ser Invocado de Modo Normal ni Colocado',
      monsterNotFound: 'No se encontró el monstruo',
      noPositionSummonTurn: 'No puedes cambiar la posición el turno en que fue invocado',
      positionAlreadyChanged: 'La posición ya cambió este turno',
      monsterAlreadyAttacked: 'Ese monstruo ya atacó',
      dragonCaptureJar:
        'Los Dragones están bloqueados en Posición de Defensa (Jarra de Captura de Dragones)',
      alreadyFaceUp: 'Ya está boca arriba',
      noFlipSetTurn: 'No puedes voltearlo el turno en que fue colocado',
      notSpellTrap: 'No es una Mágica ni una Trampa',
      noFreeSpellZone: 'No hay zona de Mágica/Trampa libre',
      notSpell: 'No es una Mágica',
      setSpellNotFound: 'No se encontró la Mágica colocada',
      setTrapNotFound: 'No se encontró la Trampa colocada',
      notTrap: 'No es una Trampa',
      trapSetDelay: 'Una Trampa no se puede activar el turno en que fue colocada',
      noDamageStep: 'Esta carta no se puede activar en el Damage Step',
      cannotActivateNow: 'Esta carta no se puede activar ahora',
      conditionsNotMet: 'No se cumplen las condiciones de activación',
      noLegalTarget: 'No hay un objetivo válido para esta carta',
      selectValidTargets: 'Elige objetivos válidos para esta carta',
      selectValidTarget: 'Elige un objetivo válido para esta carta',
      noFlipPending: 'No hay una selección de Flip Effect pendiente',
      notYourSelection: 'No te toca elegir',
      invalidTarget: 'Objetivo inválido',
      noTargetPending: 'No hay una selección de objetivo pendiente',
      attackerNotFound: 'No se encontró el atacante',
      targetNotFound: 'No se encontró el objetivo',
      cannotDirectAttack: 'El rival controla monstruos; no puedes atacar directamente',
      attackerFaceDown: 'El atacante está boca abajo',
      attackerNotAttackPos: 'El atacante no está en Posición de Ataque',
      alreadyAttacked: 'Ya atacó este turno',
      noFirstTurnAttack: 'No puedes atacar en el primer turno',
      swordsOfRevealingLight: 'No puedes atacar (Espadas de la Luz Reveladora)',
      targetNotMonster: 'El objetivo no es un monstruo',
      noPendingResponse: 'No hay una respuesta pendiente',
      notYourResponse: 'No te toca responder',
      cardCannotActivateNow: 'Esa carta no se puede activar ahora',
      chainTooLong: 'La cadena es demasiado larga',
      cannotChainSlower: 'No puedes encadenar un efecto más lento',
      spellSpeed1NoChain: 'Spell Speed 1 no se puede encadenar',
      noDiscardOwed: 'No tienes que descartar',
      cardNotYourHand: 'Esa carta no está en tu mano',
      normalSummonUsed: 'Ya usaste la Invocación Normal este turno',
      offeringPhase: 'Ofrenda Final: tu Main Phase o la Battle Phase del rival',
      notEnoughLp: 'No tienes suficientes LP',
      noOfferingMonster:
        'No hay un monstruo que puedas Invocar de Modo Normal o por Sacrificio',
      matchNotFound: 'No se encontró el duelo',
      notInMatch: 'No estás en este duelo',
      sessionMoved: 'Este duelo siguió en tu otro dispositivo',
      invalidAction: 'Acción inválida',
      spectateDenied: 'Ese duelo no se puede ver',
      internalError: 'Error interno',
    },
    msg: {
      offeringPassed: '{name}: pasó.',
      offeringAgain: '{name}: puedes Invocar de Modo Normal o Colocar otra vez.',
      unsupportedAction: 'El motor todavía no admite esta acción',
      discardDown: 'Descarta {n} carta(s) hasta {limit}.',
      flipActivated: '{name}: ¡Flip Effect activado!',
      flipNoTarget: '{name}: Flip Effect — no hay un objetivo válido',
      attackCancelled: 'El ataque se canceló: {reason}.',
      attackCancelAttacker: 'el atacante ya no puede atacar',
      attackCancelTarget: 'el objetivo dejó el campo',
      attackCancelOpp: 'el rival ahora controla un monstruo',
      wabokuDamage: '{name}: el daño de batalla pasa a ser 0.',
      kuribohDamage: '{name}: este ataque inflige 0 de daño de batalla.',
      wabokuAttacker: '{name}: el monstruo atacante no se destruye en batalla este turno.',
      wabokuDefender: '{name}: el monstruo defensor no se destruye en batalla este turno.',
      noResponse: 'Sin respuesta.',
      fizzled: '{name} se disipó (sus objetivos ya no son legales).',
      egotistNoLady: '{name}: no hay una Dama Arpía boca arriba en el Campo.',
      egotistNoZone: '{name}: no hay una zona de monstruo libre.',
      egotistNoMonster:
        '{name}: no hay Dama Arpía ni Hermanas de la Dama Arpía en tu mano o baraja.',
      noLegalTarget: '{name}: no hay un objetivo válido.',
      reverseTrap: '{name}: los modificadores de ATK y DEF se invierten hasta la End Phase.',
      bigEye: '{name}: {n} carta(s) volvieron arriba del Deck.',
      shieldSword: '{name}: el ATK y la DEF originales se intercambian hasta el final de este turno.',
      returnedToExtra: '{name} volvió al Extra Deck.',
      revealDestroyed: '{name} era una {kind} — destruida.',
      revealSetAgain: '{name} era una {kind} — se coloca de nuevo (no se destruye).',
      kindTrap: 'Trampa',
      kindSpell: 'carta Mágica',
      barrelHit: '{name}: {heads} caras. Ese monstruo se destruye.',
      barrelMiss: '{name}: {heads} caras. No se destruye nada.',
      coinCall: '{name}: elige cara o cruz.',
    },
    toast: {
      flipFirst: 'Elige primero el objetivo del Flip Effect',
      mainPhaseOnly: 'Solo puedes jugar desde la mano en tu Main Phase',
      offeringPayFirst: 'Primero paga 500 LP',
      notEnoughTribute: 'No hay suficientes monstruos para el sacrificio',
      noMonsterZone: 'No hay zona de monstruo libre',
      noSpellZone: 'No hay zona de Mágica/Trampa libre',
      notEnoughField: 'No hay suficientes monstruos en el campo para esta carta',
      noValidTarget: 'No hay un objetivo válido para esta carta',
      equipNeedsRace: 'Equípala a un monstruo de tipo {race} boca arriba',
      equipNeedsAttr: 'Equípala a un monstruo de {attr} boca arriba',
      equipNotRace: 'No puedes equiparla a un monstruo de tipo {race}',
      equipNeedsMonster: 'Equípala a un monstruo boca arriba',
      selectTarget: 'Elige un objetivo',
      fissureTie: 'Fissure: el ATK más bajo está empatado. Elige qué monstruo destruir.',
      cancelled: 'Activación cancelada',
      highlighted: 'Elige una de las cartas resaltadas',
      mustChooseTarget: 'Esta carta ya está activada — elige un objetivo',
      sistersEgotist:
        'Hermanas de la Dama Arpía solo se Invoca de Modo Especial con Egotista Elegante, desde la mano o la baraja. Tócala en esa lista y elige ataque o defensa.',
      invalidTarget: 'Esa carta no es un objetivo válido para esta carta',
      selectTribute: 'Elige {need} monstruo(s) para sacrificar ({selected}/{need})',
      clickOwnTribute: 'Toca tus propios monstruos para el sacrificio',
      soulExchangeNoZone:
        'Soul Exchange no libera una zona de monstruos. Sacrifica uno de los tuyos, o deja una zona vacía.',
      invalidStep: 'Ese monstruo no es una elección válida en este paso',
      selectAttack: 'Elige un monstruo del rival al que atacar',
      replay: 'Replay — elige un ataque nuevo o pasa',
      skipBattle: 'Este turno no puedes entrar a la Battle Phase',
      escCancel: ' — Esc para cancelar',
      destroyYours: 'Elige 2 de tus monstruos para destruir',
      destroyOpp: 'Elige el monstruo del rival para destruir',
      cocoonNeeds: 'Equípala a un Petit Moth boca arriba',
      cocoonPick: 'Elige un Petit Moth boca arriba',
      gateNeeds: 'Necesitas a Sanga of the Thunder, Kazejin y Suijin en tu campo',
      gateTributes: 'Sacrifica a Sanga of the Thunder, Kazejin y Suijin',
      larvaeNeeds: 'Petit Moth con Cocoon of Evolution, en tu turno 2',
      greatNeeds: 'Petit Moth con Cocoon of Evolution, en tu turno 4',
    },
  },
  ops: {
    kicker: 'Interno',
    title: 'Ops',
    lead: 'Cuentas, la cola, duelos en vivo, clasificatorias, cartas, copias de la colección, buzón, chat y la encuesta de la colección.',
    home: 'Inicio',
    keyLabel: 'Clave de admin',
    keyError: 'Esa clave no abre esta página.',
    unlock: 'Desbloquear',
    loadError: 'No se pudo cargar esta vista.',
    empty: 'Todavía no hay nada aquí.',
    search: 'Buscar',
    searchUsers: 'Usuario o correo',
    filterActivity: 'Actividad',
    filterAll: 'Todas',
    filterDay: 'Activos hoy',
    filterWeek: 'Activos esta semana',
    filterNew: 'Nuevos esta semana',
    filterIdle: 'Inactivos (7 días)',
    filterRole: 'Tipo',
    filterAdmins: 'Admins',
    filterPlayers: 'Jugadores',
    filterSort: 'Orden',
    sortNewest: 'Registro',
    sortSeen: 'Última vez',
    sortLevel: 'Nivel',
    sortCoins: 'Monedas',
    sortDuels: 'Duelos',
    sortCollection: 'Colección',
    sortRanked: 'Clasificatorias',
    adminBadge: 'Admin',
    portrait: {
      title: 'Retrato exclusivo',
      lead: 'Solo tu cuenta puede llevarlo. Los demás lo ven en el duelo y en el chat.',
      upload: 'Subir imagen',
      uploading: 'Subiendo…',
      uploadLead:
        'Elige una imagen desde tu computadora. Al subirla, pasa a ser tu retrato.',
      wear: 'Usar este retrato',
      wearing: 'Lo estás usando',
      error: 'No se pudo guardar el retrato.',
      uploadError: 'No se pudo guardar esa imagen.',
      badType: 'Ese archivo no es una imagen que se pueda usar.',
    },
    userCount: '{n} cuentas',
    deleteUser: 'Eliminar cuenta',
    deleteLead: 'Borra la cuenta, las barajas, el álbum y el historial. No se puede deshacer.',
    deleteAdminWarn: 'Esta cuenta también es de admin.',
    deleteType: 'Escribe {name} para confirmar',
    deleteConfirm: 'Eliminar',
    deleteCancel: 'Cancelar',
    deleteError: 'No se pudo eliminar la cuenta.',
    deleteMismatch: 'El usuario no coincide.',
    deleteSelf: 'No puedes eliminar tu propia cuenta.',
    masterPacks: 'Master Packs',
    rewardTitle: 'Enviar recompensa',
    rewardLead:
      'El jugador recibe este mensaje en su buzón y reclama ahí las monedas o los Master Packs.',
    rewardMessage: 'Mensaje',
    rewardPlaceholder: 'Escribe una nota para este jugador',
    rewardDoneMailbox: 'Enviado a su buzón.',
    rewardKind: 'Recompensa',
    rewardCoins: 'Monedas',
    rewardPacks: 'Master Packs',
    rewardQty: 'Cantidad',
    rewardSend: 'Enviar',
    rewardSending: 'Enviando…',
    rewardError: 'No se pudo enviar la recompensa.',
    rewardDoneCoins: 'Enviado. Esta cuenta ahora tiene {n} monedas.',
    rewardDonePacks: 'Enviado. Esta cuenta ahora tiene {n} Master Packs.',
    backList: 'Volver a la lista',
    prev: 'Anterior',
    next: 'Siguiente',
    tabs: {
      overview: 'Resumen',
      logs: 'Registros',
      live: 'En vivo',
      queue: 'Cola',
      users: 'Usuarios',
      duels: 'Duelos',
      cards: 'Cartas',
      decks: 'Barajas',
      pulls: 'Colección',
      ranked: 'Clasificatoria',
      chat: 'Chat',
      feedback: 'Buzón',
      poll: 'Encuesta',
      tourneys: 'Torneos',
      reset: 'Reset de expansión',
    },
    maintenance: {
      title: 'Mantenimiento',
      lead: 'Cierra el sitio ahora. No borra cuentas, cartas ni corre el reset.',
      on: 'Entrar en mantenimiento',
      confirmOn: 'Cerrar el sitio',
      confirmOnHint: 'Todos ven el cartel y se cortan los duelos. Esta página de admin sigue abierta.',
      off: 'Abrir el sitio',
      confirmOff: 'Abrir el sitio',
      confirmOffHint: 'El cartel desaparece y la clasificatoria vuelve a aceptar gente.',
      stateFull: 'El sitio está en mantenimiento.',
      stateClosed: 'La entrada está cerrada. El mantenimiento completo todavía no.',
      stateOff: 'El sitio está abierto.',
      errors: {
        failed: 'No se pudo cambiar el mantenimiento.',
        reset_in_progress: 'Hay un reset en curso. El sitio se abre al terminar ese checklist.',
      },
    },
    eventQueue: {
      title: 'Cola de evento semanal',
      lead: 'Un modo a la vez, siete días. Los duelos terminados pagan 7 monedas al ganar y 5 al perder o empatar, igual que clasificatoria. Quien gane un duelo recibe una sola banda de Master Packs, contada entre quienes ganaron: 20 el top 1%, 15 el resto del top 10%, 8 el resto del top 25%, 4 el resto del top 50% y 2 el resto. Clasificatoria y casual no cambian.',
      none: 'No hay un evento en curso.',
      live: '{mode} está activo hasta {time}.',
      mode: 'Modo',
      start: 'Iniciar 7 días',
      startConfirm: 'Iniciar',
      startHint: 'Abre esta cola por una semana. Solo puede haber un evento activo.',
      end: 'Cerrar ahora',
      endConfirm: 'Cerrar y pagar',
      endHint: 'Cierra la cola y envía Master Packs a quien tenga una victoria.',
      place: '#',
      player: 'Jugador',
      wins: 'V–D',
      notices: {
        started: 'La cola de evento está activa.',
        ended: 'El evento cerró y se enviaron los premios.',
        none: 'No había un evento activo.',
        event_live: 'Ya hay un evento activo.',
        failed: 'No se pudo cambiar la cola de evento.',
      },
    },
    tournament: {
      title: 'Torneos',
      lead: 'Los torneos automáticos usan las plazas, el arranque y el intervalo de abajo. La pausa detiene el horario. Iniciar ahora no espera ese turno. Una inscripción ya abierta conserva su cupo y su hora.',
      paused: 'Los torneos automáticos están en pausa.',
      running: 'Los torneos automáticos salen cada {n} minutos.',
      phaseNone: 'No hay un torneo abierto.',
      phaseRegistration: 'Inscripción abierta. {n} inscritos de {max}. Arranca {time}.',
      seats: 'Plazas',
      startWhenFull: 'Arrancar al llenarse',
      interval: 'Minutos entre torneos',
      save: 'Guardar',
      openKeeps: 'La inscripción abierta conserva {n} plazas.',
      phaseLive: 'Hay un torneo en juego.',
      pause: 'Pausar automáticos',
      pauseConfirm: 'Pausar',
      pauseHint: 'No se abre ni arranca otro torneo automático. El que ya está en juego sigue.',
      resume: 'Reanudar automáticos',
      resumeConfirm: 'Reanudar',
      resumeHint: 'El horario vuelve. Si había una inscripción cuyo inicio ya pasó, arranca enseguida.',
      start: 'Abrir torneo ahora',
      startConfirm: 'Abrir inscripción',
      startHint: 'La inscripción se abre ahora. Arranca en 30 minutos, o antes si arrancas el cuadro. Con la pausa activa no arranca solo.',
      begin: 'Arrancar el cuadro',
      beginConfirm: 'Arrancar ya',
      beginHint: 'Empieza con quien ya está inscrito. Hacen falta 4. Si hay menos, la inscripción sigue abierta.',
      notices: {
        opened: 'La inscripción está abierta.',
        live: 'El cuadro arrancó.',
        need_players: 'Hacen falta 4 inscritos. La inscripción sigue abierta.',
        live_busy: 'Ya hay un torneo en juego.',
        paused: 'Los torneos automáticos quedaron en pausa.',
        resumed: 'Los torneos automáticos volvieron al horario.',
        saved: 'Guardado. El próximo torneo automático usa estos valores.',
        failed: 'No se pudieron cambiar los torneos.',
      },
    },
    tourneyHistory: {
      lead: 'Los torneos de este servidor, también los que ya terminaron. Si el duelo se jugó, el cuadro tiene Ver replay. Un pase sin duelo no tiene.',
      live: 'En curso',
    },
    reset: {
      title: 'Reset de expansión',
      start: 'Empezar reset',
      confirm: 'Confirmar reset',
      confirmHint: 'Esto vacía copias, monedas, nivel, barajas, sobres y la banlist. El álbum y los cosméticos se quedan.',
      retry: 'Reintentar',
      running: 'En curso',
      done: 'Reset terminado',
      waiting: '{n} duelos en curso',
      empty: 'No hay un reset pendiente.',
      errors: {
        expansion_not_ready: 'Esta expansión todavía no está en el servidor.',
        migrations_behind: 'Faltan migraciones en la base.',
        devtools_open: 'Las herramientas de desarrollo no están cerradas.',
        step_out_of_order: 'Ese paso no es el siguiente.',
        no_reset: 'No hay un reset pendiente.',
        step_failed: 'El paso falló. Reintenta desde aquí.',
      },
      steps: {
        'expansion-ready': 'Expansión en el servidor',
        migrations: 'Migraciones al día',
        devtools: 'Herramientas de desarrollo cerradas',
        'close-entry': 'Entrada cerrada',
        'wait-duels': 'Duelos en curso terminados',
        'maintenance-full': 'Mantenimiento completo',
        backup: 'Respaldo guardado',
        'close-season': 'Temporada cerrada',
        'save-album': 'Álbum guardado',
        'wipe-copies': 'Copias en cero',
        'wipe-packs': 'Sobres reiniciados',
        'wipe-coins': 'Monedas en cero',
        'wipe-xp': 'Nivel en cero',
        'wipe-decks': 'Barajas borradas',
        'reset-league': 'Liga en colocación',
        'restore-promos': 'Promos devueltas',
        'clear-banlist': 'Banlist vacía',
        'grant-rewards': 'Premios de cierre entregados',
        'open-season': 'Temporada nueva abierta',
        'mail-special': 'Sobre especial enviado',
        'mark-done': 'Reset marcado',
        'maintenance-off': 'Sitio abierto',
      },
    },
    cardsLead:
      'Cartas que los duelistas llevan en la baraja al empezar un duelo, en esta temporada. La barra superior es el uso frente a la carta más vista. La de abajo es el porcentaje de victorias en duelos ya terminados.',
    cardsDecks: '{n} barajas',
    cardsUsage: 'Uso {n}%',
    cardsWin: 'Victorias {n}',
    cardsMinUsage: 'Uso mínimo',
    cardsMinWin: 'Victorias mínimas',
    cardsAny: 'Cualquiera',
    cardsMatch: '{n} cartas',
    cardsBanlist: 'Banlist',
    cardsBanlist1: 'Limited — máximo 1',
    cardsBanlist2: 'Semi-Limited — máximo 2',
    cardsBanlistOpen: 'Sin límite',
    cardsBanlistNot1: 'No limited a 1',
    cardsCap: 'máx. {n}',
    cardsAvg: '{n} copias por baraja',
    decksLead:
      'Duelos terminados en esta temporada, agrupados cuando las barajas principales se parecen. El Extra Deck queda fuera. Las imágenes son la lista principal más jugada del grupo. Una carta que está en al menos el 40% de esos duelos sale del nombre. En horizontal, qué tan seguida se juega. En vertical, el win rate. Arriba a la derecha es lo que más aparece y más gana.',
    decksMain: 'Baraja principal',
    decksSeason: 'Temporada',
    decksSeasonOpen: '{name} · ahora',
    deckSeason: {
      'set-mrd': 'Metal Raiders',
      'set-mrl': 'Magic Ruler',
    },
    decksBracket: 'Liga',
    decksAllLeagues: 'Todas las ligas',
    decksTop: 'Champion y King',
    decksLoading: 'Cargando barajas…',
    decksEmpty: 'Todavía no hay listas en esta temporada.',
    decksStaples: 'Base',
    decksPlay: 'Jugada en el {n}% de los duelos',
    decksWin: 'Win rate {n}',
    decksRecord: '{wins} victorias · {losses} derrotas · {draws} empates',
    decksDuels: '{n} duelos',
    decksTrend: 'Últimos 7 días {recent}% · los 7 anteriores {prev}%',
    decksTrendRecent: 'Últimos 7 días {recent}%',
    decksHidden: '{n} grupos con menos de 5 duelos no se muestran.',
    decksChart: 'Uso y win rate',
    decksPlayAxis: 'Uso',
    decksWinAxis: 'Win rate',
    pullsLead:
      'Copias que cada jugador tiene ahora. El número es cuántos la tienen. La barra compara ese número con los {players} jugadores que tienen álbum. Toca una carta para ver quién tiene 2 o 3 copias.',
    pullsLoading: 'Cargando la colección…',
    pullsSummary:
      '{cards} cartas · {none} sin dueño · {two} con 2 copias · {playset} con 3 copias',
    pullsSortFew: 'Menos jugadores',
    pullsSortMany: 'Más jugadores',
    pullsSortCatalog: 'Orden del álbum',
    pullsAll: 'Todas',
    pullsTwo: 'Con 2',
    pullsThree: 'Con 3',
    pullsNone: 'Nadie',
    pullsLegendThree: 'Alguien tiene 3',
    pullsLegendTwo: 'Alguien tiene 2',
    pullsLegendNone: 'Nadie la tiene',
    pullsOwners: '{n} de {players}',
    pullsCopies: '{n} copias',
    pullsNobody: 'Nadie tiene 2 o más copias.',
    pullsPick: 'Toca una carta para ver los nombres.',
    pullsTile: '{name}. {n} jugadores, {two} con 2 copias, {three} con 3.',
    pollLead:
      'Votos sobre cartas prohibidas ya, o por ahora solo cartas limitadas. Una prohibida no se puede jugar: 0 copias.',
    pollForbidden: 'Cartas prohibidas',
    pollLimited: 'Solo limitadas',
    pollNone: 'Sin voto',
    pollTally: '{forbidden} prohibidas · {limited} solo limitadas',
    pollEmpty: 'Todavía no hay votos.',
    bugReal: 'Era real',
    bugDismiss: 'No era un bug',
    bugPending: 'Pendiente',
    bugPaid: 'Sobre pagado',
    bugDismissed: 'Descartado',
    bugReviewError: 'No se pudo guardar la revisión.',
    bugReply: 'Responder',
    bugReplied: 'Respondido',
    bugReplyTitle: 'Responder a {name}',
    bugReplyLead:
      'Cierra este reporte. El jugador recibe el mensaje en su buzón y reclama ahí la recompensa.',
    bugReplyMessage: 'Mensaje',
    bugReplyCoins: 'Monedas',
    bugReplyPacks: 'Master Packs',
    bugReplyHint: 'Usa 0 si no quieres esa recompensa.',
    bugReplySend: 'Enviar y cerrar',
    bugReplySending: 'Enviando…',
    bugReplyCancel: 'Cancelar',
    bugReplyError: 'No se pudo enviar la respuesta.',
    devices: 'Dispositivos',
    deviceNone: 'Todavía no hay un dispositivo guardado.',
    deviceUnknown: 'Desconocido',
    deviceInstalled: 'App instalada',
    deviceBrowser: 'Navegador',
    deviceFullscreen: 'Pantalla completa',
    deviceTouch: 'Táctil',
    devicePointer: 'Puntero',
    deviceLock: 'Bloqueo horizontal',
    deviceNoLock: 'Sin bloqueo horizontal',
    liveLead:
      'Duelos que se están jugando ahora. Esta lista se actualiza sola. En PvP puedes abrir el tablero. Los duelos vs IA se pueden terminar aquí, y se cierran solos al cumplirse una hora.',
    watch: 'Ver',
    liveFilter: 'Mostrar',
    liveAll: 'Todos',
    liveAi: 'Vs IA',
    livePvp: 'PvP',
    modeAi: 'Vs IA',
    modeCasual: 'Casual',
    modeRanked: 'Clasificatoria',
    modeEvent: 'Evento',
    liveHand: 'mano',
    liveDeck: 'baraja',
    offline: 'desconectado',
    liveEmpty: 'Nadie está en un duelo ahora.',
    queueLead:
      'Cuentas esperando Partida rápida. Se emparejan cuando la diferencia de rating cabe en la ventana de quien lleva menos tiempo. Empieza en ±{start}, pasa a ±{mid} a los {midWait} s y se abre a los {openWait} s. Si esta semana hay menos de {pool} cuentas en clasificatoria, la ventana queda abierta. Esta lista se actualiza sola.',
    queueEmpty: 'Nadie está en la cola.',
    queueGate: 'Partida rápida',
    queueGateOn: 'Abierta. Los duelistas pueden entrar a la cola.',
    queueGateOff:
      'Cerrada. Nadie nuevo puede empezar un duelo clasificatorio. Quien ya espera vuelve al inicio. Los duelos en curso siguen. La cola se abre de nuevo cuando este servidor reinicia.',
    queueGateError: 'No se pudo cambiar la cola.',
    queueCount: '{n} en cola',
    queuePairReady: 'Hay un emparejamiento posible. El servidor lo revisa cada 5 segundos.',
    queuePairBlocked: '{n} en cola, y todavía ninguno está lo bastante cerca.',
    queueSmallPool: 'Pocas cuentas clasificatorias esta semana ({n}). La ventana se queda abierta.',
    queueNormalPool: 'Cuentas clasificatorias esta semana: {n}.',
    queueRating: 'Rating {rating} · RD {rd}',
    queuePlacement: 'Colocación · faltan {n}',
    queueLeagueLp: '{name} · {lp} LP',
    queueWindow: 'Ventana propia: ±{n}',
    queueWindowOpen: 'Ventana propia: abierta',
    queueAlone: 'Esperando a otra cuenta.',
    queueNearestYes: 'Puede emparejar con {name} (diferencia {diff}).',
    queueNearestNo: 'El más cercano es {name}, a {diff} de rating. Todavía le faltan {short} para entrar en la ventana.',
    queueShowDeck: 'Ver baraja',
    queueHideDeck: 'Ocultar baraja',
    queueMat: 'Tapete: {name}',
    queueAccount: 'Ver cuenta',
    liveEnd: 'Terminar duelo',
    liveEndConfirm: 'Terminarlo',
    liveEndCancel: 'Cancelar',
    usersTotal: 'Cuentas',
    activeDay: 'Activos hoy',
    activeWeek: 'Activos esta semana',
    newWeek: 'Nuevos esta semana',
    dropoutTitle: 'Tasa de deserción',
    dropoutLead: 'Cuentas con más de 7 días. No volvieron: un solo inicio de sesión.',
    dropoutGauge: 'Deserción {n} por ciento',
    dropoutCreated: 'Creadas',
    dropoutReturned: 'Volvieron alguna vez',
    dropoutGone: 'No volvieron',
    dropoutWeeks: 'Por semana de registro',
    dropoutWeeksLead: 'Segundo inicio de sesión dentro de 7 días. Solo semanas ya cerradas.',
    dropoutBack: 'Volvieron',
    dropoutNever: 'No volvieron',
    dropoutCurve: 'Curva de retorno',
    dropoutCurveLead:
      'Porcentaje con un segundo inicio de sesión a ese día. Cuentas de los últimos 120 días que ya cumplieron el día.',
    dropoutDay: 'Día {n}',
    packsWeek: 'Sobres abiertos (7d)',
    coinsWeek: 'Monedas creadas / gastadas (7d)',
    chatWeek: 'Mensajes de chat (7d)',
    logsLead: 'Cada lista va en su propia pestaña. El resumen solo muestra los totales.',
    logs: {
      stall: 'Trabas',
      fault: 'Fallos',
      summon: 'Invocación',
      probe: 'Casos',
      entry: 'Entrada',
      pvp: 'PvP',
    },
    probeLog: 'Rechazos, conexiones y cartas sin dibujar (7d)',
    probeLead:
      'Un rechazo es un clic que el servidor no aceptó. La conexión es el socket. Sin dibujar es una carta que el duelo tenía y el tablero no mostró.',
    probe: {
      action_rejected: 'Rechazo',
      duel_link: 'Conexión',
      board_gap: 'Sin dibujar',
      duel_hidden: 'Pestaña oculta',
    },
    entryLead:
      'La primera vez que un jugador abre su sala del torneo. El aviso es el cuadro de diálogo. La notificación es el aviso del sistema. El cuadro es el botón en el cuadro. Siguiente ronda es cuando el juego lo pasa solo.',
    entryHow: 'Cómo entró',
    entryVia: {
      dialog: 'Aviso',
      notice: 'Notificación',
      bracket: 'Cuadro',
      advance: 'Siguiente ronda',
      unknown: 'Sin dato',
    },
    pvpLogLead:
      'Jugadas de duelos entre dos personas, con las dos manos iniciales. Los duelos anteriores no aparecen.',
    pvpLogHands: 'Manos iniciales',
    pvpLogFirst: '{name} empieza',
    pvpLogTrimmed: 'Las primeras jugadas no cupieron. Aquí está el final.',
    pvpLogOpen: 'Ver jugadas',
    pvpLogClose: 'Ocultar jugadas',
    pvpLogLoading: 'Cargando jugadas…',
    pvpLogSet: '{name} colocó {card}',
    pvpLogGy: '{card} fue al Cementerio',
    pvpLogPeek: '{name} miró {cards}',
    pvpLogPeekReveal: '{name} reveló {cards}',
    pvpLogAsk: '{name} debe elegir para {card}: {target} ({where})',
    pvpLogAskLeft:
      '{name} seguía sin elegir objetivo de {card} cuando terminó el duelo ({n})',
    pvpAsk: {
      set: 'boca abajo',
      def: 'Defensa',
      atk: 'Ataque',
      up: 'boca arriba',
      gy: 'Cementerio',
      hand: 'mano',
      deck: 'Baraja',
      ban: 'retirada del juego',
      extra: 'Extra Deck',
      zone: '{where}, zona {n}',
    },
    summonLocksWeek: 'Invocación trabada (7d)',
    summonLockLog: 'Últimas invocaciones trabadas',
    summonLock: {
      throw: 'La animación falló',
      watchdog: 'El seguro soltó el tablero',
      resync: 'Pidió el estado otra vez',
    },
    stallsWeek: 'Trabas en Battle Phase (7d)',
    stallReason: 'Causa',
    stall: {
      playback: 'Animación trabada',
      substep: 'Paso de batalla trabado',
      prompt: 'Falta el aviso',
      ai: 'La IA no sigue',
    },
    stallLog: 'Últimas trabas',
    stallTurn: 'Turno',
    stallSeat: 'Le toca',
    stallAnswer: 'Debe responder',
    stallMe: 'este jugador',
    stallOpp: 'el rival',
    stallPrompt: 'Aviso',
    stallAttack: 'Ataque',
    stallChain: 'Cadena',
    stallField: 'Monstruos',
    stallBack: 'Mágicas y trampas',
    stallRecent: 'Últimos eventos',
    faultsWeek: 'Trap Hole, Ofrenda Final y Last Will (7d)',
    faultLog: 'Últimos fallos de esas cartas',
    faultCard: 'Carta',
    faultCardName: {
      trap_hole: 'Trap Hole',
      offering: 'Ofrenda Final',
      last_will: 'Last Will',
    },
    fault: {
      target: 'Pidió un objetivo',
      prompt: 'Falta el aviso',
      offering_hand: 'La mano no dejó invocar',
      wrong_turn: 'Se disparó fuera de su turno',
    },
    duelsWeek: 'Duelos (7d)',
    aiWeek: 'Vs IA (7d)',
    mode: 'Modo',
    count: 'Cantidad',
    wins: 'Victorias',
    difficulty: 'Dificultad',
    username: 'Usuario',
    email: 'Correo',
    lastSeen: 'Última vez',
    level: 'Nivel',
    coins: 'Monedas',
    duelsCol: 'Duelos',
    playTime: 'Tiempo jugado',
    playMinutes: '{n} min',
    playHours: '{n} h',
    playHoursMinutes: '{h} h {m} min',
    collectionCol: 'Cartas',
    decksCol: 'Barajas',
    uniqueShort: '{n} únicas',
    created: 'Alta',
    albumCopies: 'Cartas en el álbum',
    album: 'Cartas únicas',
    decks: 'Barajas',
    deckActive: 'En uso',
    deckMain: 'Baraja principal',
    deckExtra: 'Baraja extra',
    recentDuels: 'Duelos recientes',
    recentPackBuys: 'Compras de sobres',
    packBuyItem: 'Sobre',
    packBuyOk: 'Comprado',
    recentChat: 'Chat reciente',
    settingsSaved: 'Guardado {when}',
    prefOn: 'Sí',
    prefOff: 'No',
    channel: 'Canal',
    allChats: 'Todos los chats',
    chatGlobal: 'Global',
    chatRoom: 'Duelo',
    chatSearch: 'Usuario o mensaje',
    when: 'Cuándo',
    result: 'Resultado',
    source: 'Fuente',
    allModes: 'Todos los modos',
    rankedLead:
      'Cada partida rápida queda registrada con los puntos de liga de los dos jugadores. Las partidas de antes de este registro solo muestran el cambio de puntos.',
    rankedSearch: 'Usuario',
    rankedCount: '{n} partidas',
    rankedPlayer: 'Jugador',
    rankedOpponent: 'Rival',
    rankedPoints: 'Puntos',
    rankedAfter: 'Después',
    rankedWinner: 'Ganó',
    rankedHistory: 'Clasificatorias',
    rankedPlayed: 'Partidas',
    rankedWins: 'Victorias',
    rankedLosses: 'Derrotas',
    rankedDraws: 'Empates',
    rankedGained: 'Puntos ganados',
    rankedLost: 'Puntos perdidos',
    rankedWin: 'Victoria',
    rankedLoss: 'Derrota',
    rankedDraw: 'Empate',
    rankedPlacement: 'Colocación · quedan {n}',
    rankedPlacementDone: 'Colocación terminada',
    rankedNone: 'Sin rango',
    rankedStanding: 'Rango',
    rankedCol: 'Clasificatorias',
  },
}
